import 'material-icons/iconfont/material-icons.css';
import '@fontsource/geologica';
import '@fontsource/geologica/300.css';
import '@fontsource/geologica/400.css';
import '@fontsource/geologica/500.css';
import '@fontsource/geologica/600.css';
import '@fontsource/geologica/700.css';
import '@fontsource/geologica/800.css';
import * as React from 'react';
import React__default, { createContext, useContext, useState, useEffect, Children, isValidElement, cloneElement, useMemo, Fragment, memo, useCallback } from 'react';
import { useAuthProvider, useAuthState, useTranslate, useGetIdentity, ComponentPropType, Resource, createAdminStore, useResourceContext, usePaginationState, useSortState, useFilterState, useSelectionState, useGetList, useReference, getStatusForInput, useInput as useInput$1, warning, ResourceContextProvider as ResourceContextProvider$1, ListContextProvider } from 'ra-core';
import { useSelector, useDispatch, Provider, shallowEqual } from 'react-redux';
import { createHashHistory } from 'history';
import { useLogout, MenuItemLink, UserMenu, HideOnScroll, setSidebarVisibility, SidebarToggleButton, LoadingIndicator, Layout, CRUD_UPDATE_SUCCESS, CRUD_UPDATE_FAILURE, CRUD_CREATE_FAILURE, CRUD_CREATE_SUCCESS, useRedirect, Button as Button$1, Admin, Login, useTranslate as useTranslate$1, useInput, Labeled, InputHelperText, ResourceContextProvider, List as List$1, useNotify, FieldTitle, DatagridRow, PureDatagridRow, useDataProvider, useRefresh, linkToRecord, DatagridCell, Datagrid } from 'react-admin';
import defaultMessages from 'ra-language-english';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import { User, WebStorageStateStore, UserManager } from 'oidc-client-ts';
import axios from 'axios';
import { Alert } from '@material-ui/lab';
import { Error as Error$1, AccountCircle, ExitToApp, FiberManualRecord, Delete, CloudDownload, CloudUpload } from '@material-ui/icons';
import { makeStyles, useTheme, useMediaQuery, Box, CircularProgress, createStyles, Tooltip, Button, Menu, MenuItem, Avatar, ListItemIcon, Typography, Collapse, Divider, List, Icon, AppBar, Toolbar, FormHelperText, LinearProgress, IconButton, Paper, TextField, TableBody, TableRow, TableCell, Checkbox as Checkbox$1, ButtonGroup } from '@material-ui/core';
import IconExpandLess from '@material-ui/icons/ExpandLess';
import IconExpandMore from '@material-ui/icons/ExpandMore';
import { useLocation, useHistory } from 'react-router';
import PropTypes from 'prop-types';
import { makeStyles as makeStyles$1, createTheme } from '@material-ui/core/styles';
import { Route, useHistory as useHistory$1 } from 'react-router-dom';
import BlockIcon from '@material-ui/icons/Block';
import History from '@material-ui/icons/History';
import Home from '@material-ui/icons/Home';
import get from 'lodash/get';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import { useDropzone } from 'react-dropzone';
import { useFormState, useForm, Form } from 'react-final-form';
import { Labeled as Labeled$1, LinearProgress as LinearProgress$1 } from 'ra-ui-materialui';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Menu$1 from '@material-ui/core/Menu';
import MenuItem$1 from '@material-ui/core/MenuItem';
import { useLocalStorage, writeStorage } from '@rehooks/local-storage';
import ViewWeekIcon from '@material-ui/icons/ViewWeek';
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardDateTimePicker } from '@material-ui/pickers';
import DayjsUtils from '@date-io/dayjs';
import tr from 'dayjs/locale/tr';
import TextField$1 from '@material-ui/core/TextField';
import InputMask from 'react-input-mask';
import classnames from 'classnames';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import CircularProgress$1 from '@material-ui/core/CircularProgress';
import ContentAdd from '@material-ui/icons/Add';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "body {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: Geologica, Arial, sans-serif;\r\n}\r\n";
styleInject(css_248z);

const TtmsAppConfigContext = createContext({});
const useTtmsAppConfig = () => useContext(TtmsAppConfigContext);
const TtmsAppConfigProvider = ({ children, config }) => {
    return React__default.createElement(TtmsAppConfigContext.Provider, { value: config }, children);
};

function getEnvironmentConfig(configModule, env = process.env.APP_ENV || process.env.NODE_ENV || "production") {
    console.log("Current environment: ", env);
    let { [env]: config } = configModule;
    if (config === undefined) {
        throw new Error(`Environment config for "${env}" is not defined`);
    }
    return config;
}

const ALLOW_ANONYMOUS_STATUS = "ALLOW_ANONYMOUS_STATUS";
const initialState$1 = {};
const allowAnonymousReducer = (state = initialState$1, action) => {
    if (action.type === ALLOW_ANONYMOUS_STATUS) {
        return {
            ...state,
            data: action.allowAnonymous,
        };
    }
    return state;
};
const changeAllowAnonymous = (allowAnonymous) => {
    return {
        type: ALLOW_ANONYMOUS_STATUS,
        allowAnonymous,
    };
};
const allowAnonymousSelector = (state) => {
    return state.allowAnonymous.data;
};

class TtmsAuthService {
    constructor(ttmsConfig, transformUser) {
        this._user = null;
        this._oidcUser = null;
        this._listeners = [];
        this._isAuthenticated = false;
        this.processCallback = async () => {
            try {
                const user = await this.userManager.signinCallback(window.location.href);
                if (user instanceof User) {
                    await this.onOidcUser(user);
                    return { state: user.state, user: this._user };
                }
                console.warn("failed to process auth callback");
                return { state: undefined, user: this._user };
            }
            catch (e) {
                console.warn("failed to process auth callback", e.message);
            }
            return { state: undefined, user: this._user };
        };
        this.onAuthStatusChanged = (callback) => {
            this._listeners.push(callback);
        };
        this.login = async (state) => {
            await this.userManager.removeUser();
            await this.userManager.clearStaleState();
            console.log("redirecting user with state", state);
            await this.userManager.signinRedirect({ state });
        };
        this.logout = async () => {
            await this.userManager.clearStaleState();
            await this.userManager.signoutRedirect();
            // await this.userManager.removeUser();
            // await this.onOidcUser(null);
        };
        this.notify = () => {
            this._listeners.forEach((cb) => {
                const tokens = this._oidcUser
                    ? {
                        idToken: this._oidcUser.id_token,
                        accessToken: this._oidcUser.access_token,
                    }
                    : null;
                cb(this._user, tokens);
            });
        };
        this.createOidcConfig = (config) => {
            const mandatoryScopes = "openid offline_access custom.profile ums commonapi";
            const allScopes = new Set(`${mandatoryScopes} ${config.scope}`.trim().split(/\s+/));
            const scope = Array.from(allScopes).join(" ");
            /* eslint-disable @typescript-eslint/camelcase */
            return {
                authority: config.authority,
                client_id: config.clientId,
                redirect_uri: config.redirectUri || window.location.href.split("/#")[0],
                scope,
                response_type: "code",
                userStore: new WebStorageStateStore({ store: window.localStorage }),
                monitorSession: false,
                accessTokenExpiringNotificationTimeInSeconds: 60,
                post_logout_redirect_uri: config.logoutRedirectUri,
            };
            /* eslint-enable @typescript-eslint/camelcase */
        };
        this.onTokenExpiring = async () => {
            let user = null;
            try {
                user = await this.userManager.signinSilent();
            }
            catch (e) { }
            if (user) {
                await this.onOidcUser(user);
                console.log(`token refreshed. next expiration in ${user.expires_in} seconds`);
            }
            else {
                console.log("token will expire soon");
            }
        };
        this.onTokenExpired = async () => {
            await this.onOidcUser(null);
        };
        this.onRefreshError = async (error) => {
            console.log("token refresh error", error.message);
        };
        this.createTtmsUser = (user, permissions, userPhoto) => {
            var _a, _b, _c, _d, _e, _f;
            const { profile } = user;
            for (const k in profile) {
                if (typeof profile[k] === "string") {
                    profile[k] = profile[k].trim();
                }
            }
            const hasPermission = (permission) => {
                return permissions.includes(permission);
            };
            let loginType = {
                1: "internal",
                2: "customer",
                3: "impersonation",
            }[profile.login_type];
            const ttmsUser = {
                employeeId: (_a = profile.register_id) === null || _a === void 0 ? void 0 : _a.toString(),
                email: profile.email || "",
                title: (_b = profile.title) === null || _b === void 0 ? void 0 : _b.toString(),
                department: (_c = profile.department) === null || _c === void 0 ? void 0 : _c.toString(),
                firstName: (_d = profile.first_name) === null || _d === void 0 ? void 0 : _d.toString(),
                lastName: (_e = profile.surname) === null || _e === void 0 ? void 0 : _e.toString(),
                fullName: [profile.first_name, profile.surname].join(" "),
                username: (_f = profile.ldap_name) === null || _f === void 0 ? void 0 : _f.toString(),
                userPhoto: userPhoto,
                loginType: loginType,
                isCustomer: loginType === "customer",
                permissions,
                roles: permissions,
                can: hasPermission,
                hasPermission,
            };
            Object.freeze(ttmsUser);
            return ttmsUser;
        };
        this.authConfig = ttmsConfig;
        const um = new UserManager(this.createOidcConfig(ttmsConfig));
        um.events.addAccessTokenExpiring(() => this.onTokenExpiring());
        um.events.addAccessTokenExpired(() => this.onTokenExpired());
        um.events.addSilentRenewError((error) => this.onRefreshError(error));
        um.events.addUserLoaded(async (user) => await this.onOidcUser(user));
        this.userManager = um;
        this._transformUser = transformUser;
    }
    getPermissionEndpoint() {
        if (this.authConfig.umsPermissionsUri) {
            return this.authConfig.umsPermissionsUri;
        }
        const authUrl = this.authConfig.authority;
        let umsBaseUrl = "https://api.turkishtechnic.com/ums";
        if (authUrl.includes("devauth.")) {
            umsBaseUrl = `https://devapi.turkishtechnic.com/ums`;
        }
        if (authUrl.includes("testauth")) {
            umsBaseUrl = `https://testapi.turkishtechnic.com/ums`;
        }
        return `${umsBaseUrl}/V3/Users/AllRolesInScope`;
    }
    getUserPhotoEndpoint() {
        const authUrl = this.authConfig.authority;
        let commonApiBaseUrl = "https://api.turkishtechnic.com/commonapi";
        if (authUrl.includes("devauth.")) {
            commonApiBaseUrl = `https://devapi.turkishtechnic.com/commonapi`;
        }
        if (authUrl.includes("testauth")) {
            commonApiBaseUrl = `https://testapi.turkishtechnic.com/commonapi`;
        }
        return `${commonApiBaseUrl}/GetUserPhotoByRegisterId`;
    }
    async fetchPermissions() {
        if (!this._oidcUser)
            return [];
        const url = this.getPermissionEndpoint();
        console.log(`fetching permissions from ${url}`);
        const res = await axios.get(url, {
            headers: { authorization: `Bearer ${this._oidcUser.access_token}` },
            timeout: 6000,
            timeoutErrorMessage: "cannot connect to UMS",
        });
        if (res.status >= 400 || res.data.StatusCode >= 400) {
            return [];
        }
        const { data } = res;
        return data.Result.map((it) => `${it.Project}.${it.Role}`);
    }
    async fetchUserPhoto() {
        if (!this._oidcUser)
            return "";
        const url = `${this.getUserPhotoEndpoint()}/${this._oidcUser.profile.register_id}`;
        const res = await axios.get(url, {
            headers: { authorization: `Bearer ${this._oidcUser.access_token}` },
            timeout: 6000,
            timeoutErrorMessage: "cannot connect to CommonAPI",
        });
        if (res.status >= 400 || res.data.StatusCode >= 400) {
            return "";
        }
        const { data } = res;
        return data.Result.photo.includes("4QA6RXhpZgAATU0AKgAAAAgAA1EQAAEAAAABAQAAAFERAAQAAAABAAAAAFESAAQAAAABAAAAAAAAAAD")
            ? ""
            : data.Result.photo;
    }
    get isAuthenticated() {
        return this._isAuthenticated;
    }
    async getUser() {
        if (this._user == null) {
            const user = await this.userManager.getUser();
            await this.onOidcUser(user);
        }
        return this._user;
    }
    async onOidcUser(user) {
        if (user === null || user === void 0 ? void 0 : user.expired) {
            // no use saving an expired token.
            user = null;
        }
        if (user !== null) {
            this._oidcUser = user;
            const permissions = await this.fetchPermissions();
            const userPhoto = await this.fetchUserPhoto();
            this._user = this.createTtmsUser(user, permissions, userPhoto);
            this._isAuthenticated = true;
            localStorage.setItem("token", user.access_token);
        }
        else {
            this._oidcUser = null;
            this._user = null;
            this._isAuthenticated = false;
            localStorage.removeItem("token");
        }
        //user info expanding with transformUser
        if (this._transformUser && user) {
            this._user = {
                ...this._user,
                ...(await this._transformUser({
                    user: this._user,
                    http: axios.create({ headers: { Authorization: `Bearer ${user.access_token}` } }),
                })),
            };
        }
        this.notify();
    }
}

const TtmsAuthContext = createContext({});
const useTtmsAuth = () => useContext(TtmsAuthContext);
const TtmsAuthProvider = ({ config, transformUser, children, allowAnonymous, }) => {
    const [authService, setAuthService] = useState();
    const [loading, setLoading] = useState(true);
    const [authState, setAuthState] = useState({ tokens: null, user: null, isAuthorized: false, errors: [] });
    useEffect(() => {
        store === null || store === void 0 ? void 0 : store.dispatch(changeAllowAnonymous(allowAnonymous));
        const init = async () => {
            const service = new TtmsAuthService(config, transformUser);
            service.onAuthStatusChanged((user, tokens) => {
                setAuthState(() => ({
                    user,
                    tokens,
                    isAuthorized: !!user,
                    errors: [],
                }));
            });
            setAuthService(service);
            try {
                let user = await service.getUser();
                if (user === null) {
                    const params = new URLSearchParams(window.location.search);
                    if (params.has("code") && params.has("state")) {
                        console.log("url includes auth params");
                        const { user, state: { returnPathWithParams, returnPath } = {} } = await service.processCallback();
                        if (user !== null) {
                            console.log("fetched user using auth code");
                            if (returnPathWithParams !== undefined) {
                                window.location.hash = `#${returnPathWithParams}`;
                            }
                            else if (returnPath !== undefined) {
                                window.location.hash = `#${returnPath}`;
                            }
                            window.location.href = window.location.pathname + window.location.hash;
                        }
                    }
                    else if (params.has("error")) {
                        const error = params.get("error_description");
                        setAuthState((a) => ({
                            ...a,
                            errors: [error],
                        }));
                    }
                }
            }
            catch (e) {
                setAuthState((a) => ({
                    ...a,
                    errors: [e.message],
                }));
            }
            setLoading(false);
        };
        init();
    }, [config]);
    const logout = async () => {
        await (authService === null || authService === void 0 ? void 0 : authService.logout());
    };
    const login = async (state) => {
        await (authService === null || authService === void 0 ? void 0 : authService.login(state));
    };
    return (React__default.createElement(TtmsAuthContext.Provider, { value: {
            user: authState.user,
            isAuthorized: authState.isAuthorized,
            tokens: authState.tokens,
            errors: authState.errors,
            loading,
            authService: authService,
            logout,
            login,
            allowAnonymous,
        } }, children));
};

const createTtmsAuthProvider = (authService) => {
    return {
        login: async () => { },
        logout: async () => { },
        checkAuth: async () => {
            if (!authService.isAuthenticated) {
                return Promise.reject(new Error("not authenticated"));
            }
            return Promise.resolve();
        },
        checkError: async (error) => {
            var _a, _b;
            if ((error === null || error === void 0 ? void 0 : error.status) === 401 || (error === null || error === void 0 ? void 0 : error.status) === 403 || ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 || ((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status) === 403) {
                console.error("auth-provider auth error", error);
                return Promise.reject(new Error("not authenticated"));
            }
            return Promise.resolve();
        },
        getPermissions: async () => {
            return Promise.resolve();
        }
    };
};

const CenteredContent = ({ children }) => {
    return (React__default.createElement("div", { style: {
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column"
        } }, children));
};

const useStyles$8 = makeStyles((theme) => ({
    logoForWeb: {
        width: "190px",
        height: "30px",
        padding: "2px 12px 4px 6px",
    },
    logoForMobile: {
        width: "32px",
        height: "32px",
        padding: "4px 20px 4px 6px",
    }
}));
const TTLogo = () => {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
    const classes = useStyles$8();
    return isSmall ? (React__default.createElement("div", { className: classes.logoForMobile },
        React__default.createElement(TTLogoForMobile, null),
        " "))
        : (React__default.createElement("div", { className: classes.logoForWeb },
            React__default.createElement(TTLogoForWeb, null),
            " "));
};
const TTLogoForWeb = () => (React__default.createElement("svg", { version: "1.2", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1054 168" },
    React__default.createElement("defs", null,
        React__default.createElement("clipPath", { clipPathUnits: "userSpaceOnUse", id: "cp1" },
            React__default.createElement("path", { d: "m-65-65h1183.91v298.24h-1183.91z" }))),
    React__default.createElement("g", { clipPath: "url(#cp1)" },
        React__default.createElement("path", { fillRule: "evenodd", style: { fill: "#fff" }, d: "m92.8 0.9c42.1 4.4 74.9 39.9 74.9 83.1 0 46.2-37.4 83.7-83.6 83.7-46.1 0-83.6-37.4-83.6-83.6 0-46.2 37.4-83.6 83.6-83.6q1.1 0 2.2 0 1.1 0 2.2 0.1 1.1 0 2.2 0.1 1.1 0.1 2.1 0.2zm4.4 161c42.9-7.3 71.9-47.9 64.7-90.9-6-35.7-35.2-61.8-69.5-65.4q-2.7-0.3-5.4-0.4-2.7-0.1-5.3 0-2.7 0.1-5.4 0.4-2.6 0.2-5.3 0.7-3.1 0.5-6.2 1.3-3 0.8-6 1.8-3 1-5.9 2.2-2.9 1.3-5.7 2.8c37.9 12.8 58.2 32.3 59.6 52.3 0.7 12.4-5 21.3-12.6 28.6l53.6-3.7c1.5-0.1 2 1.6 0.1 2.2l-127.7 36.6c13 17.9 33.2 29.8 55.6 32.1q2.7 0.3 5.4 0.4 2.6 0.1 5.3 0 2.7-0.1 5.4-0.3 2.6-0.3 5.3-0.7zm-35.2-76c7-26.3-1-53.9-20.1-68.5-26 16.5-41 47.5-35.6 79.7q0.7 3.9 1.7 7.7 1 3.8 2.4 7.4 1.4 3.7 3.2 7.2 1.7 3.5 3.8 6.8c20.4-5.7 38.3-16.4 44.6-40.3z" }),
        React__default.createElement("path", { fillRule: "evenodd", style: { fill: "#c80c0f" }, d: "m41.9 17.4c19.1 14.6 27.1 42.2 20.1 68.5-6.3 23.9-24.2 34.6-44.6 40.3q-2.1-3.3-3.8-6.8-1.8-3.5-3.2-7.2-1.4-3.6-2.4-7.4-1-3.8-1.7-7.7c-5.4-32.2 9.6-63.2 35.6-79.7zm50.5-11.8q-2.7-0.3-5.4-0.4-2.7-0.1-5.3 0-2.7 0.1-5.4 0.4-2.6 0.2-5.3 0.7-3.1 0.5-6.2 1.3-3 0.8-6 1.8-3 1-5.9 2.2-2.9 1.3-5.7 2.8c37.9 12.8 58.2 32.3 59.6 52.3 0.7 12.4-5 21.3-12.6 28.6l53.6-3.7c1.5-0.1 2 1.6 0.1 2.2l-127.7 36.6c13 17.9 33.2 29.8 55.6 32.1q2.7 0.3 5.4 0.4 2.6 0.1 5.3 0 2.7-0.1 5.4-0.3 2.6-0.3 5.3-0.7c42.9-7.3 71.9-47.9 64.7-90.9-6-35.7-35.2-61.8-69.5-65.4z" }),
        React__default.createElement("path", { d: "m600.8 116.9v-27.5h-27.5v27.5h-15.2v-65.5h15.2v26.1h27.5v-26.1h15.3v65.5z" }),
        React__default.createElement("path", { d: "m289.9 51.4v40.5c0 4.2 1 7.5 3.1 10 2.1 2.5 5.3 3.7 9.7 3.7 4.4 0 7.7-1.2 9.7-3.7 2-2.5 3.1-5.8 3.1-10v-40.5h14.1v41c0 4.5-0.6 8.5-1.8 11.6-1.3 3.2-3.1 5.8-5.3 7.9-2.3 2-5.1 3.5-8.4 4.4-3.4 1-7.2 1.4-11.4 1.4-4.3 0-8.1-0.4-11.6-1.4-3.3-0.9-6.3-2.4-8.8-4.5-2.4-2-4.3-4.6-5.6-7.8-1.3-3.2-2-7.1-2-11.6v-41z" }),
        React__default.createElement("path", { d: "m231.1 116.9v-53.3h-17.8v-12.2h50.8v5.8q0 1.3-0.5 2.5-0.5 1.1-1.4 2-0.9 0.9-2 1.4-1.2 0.5-2.5 0.5h-11.5v53.3z" }),
        React__default.createElement("path", { d: "m474.3 51.4h15.1v65.5h-15.1z" }),
        React__default.createElement("path", { d: "m423.9 87.5v29.3h-15.2v-65.4h15.2v27.7 1.2l0.5-0.7 20.9-28.2h15.7l-22.7 29.2-0.4 0.5 0.4 0.6 27.7 35.2h-12.1q-1.5 0-2.9-0.3-1.4-0.4-2.8-1-1.3-0.7-2.4-1.6-1.2-0.9-2.1-2.1l-19.3-24.9-0.5-0.7z" }),
        React__default.createElement("path", { fillRule: "evenodd", d: "m389 116.9q-1.7 0-3.3-0.5-1.6-0.4-3-1.2-1.5-0.8-2.7-2-1.2-1.1-2-2.6l-11.8-19.4h-7.5v25.7h-15.1v-65.5h27c6.9 0 12.3 1.8 16.1 5.4 3.8 3.5 5.7 8.4 5.7 14.4 0 3.1-0.8 6.2-2.5 9.3-1.5 3-4.4 5.5-8.3 7.3l-0.9 0.4 18.3 28.7zm-30.2-35.5h8.8c3.2 0 5.6-0.9 7.2-2.6 1.6-1.7 2.4-3.9 2.4-6.6 0-2.7-0.8-4.9-2.3-6.6-1.6-1.8-4-2.6-7.3-2.6h-8.8z" }),
        React__default.createElement("path", { d: "m501.8 114.1v-12.6c4.9 2.2 11.1 4.5 17.5 4.5 7.4 0 11.1-2.6 11.1-7.4 0-5.7-5-6.4-15.1-10.7-6.8-3-13.4-7.8-13.4-18.8 0-12.7 9.8-18.7 23.3-18.7 7.1 0 13.2 1.6 16.7 2.9v12.3c-3.5-1.6-9.6-3.5-15.7-3.5-6.6 0-9.7 2.4-9.7 6.6 0 4.4 3.7 5.8 10.5 8.4 8.7 4.3 18.7 6.2 18.7 20.9 0 12.8-10.1 19.8-23.7 19.8-8.4 0-15-1.5-20.2-3.7z" }),
        React__default.createElement("path", { d: "m764.2 84.9c0-19.1 10.3-34.8 32-34.8 8 0 13 1.6 16.4 3v12.6c-3.2-1.9-8.2-3.4-14.8-3.4-11.7 0-18.1 7.8-18.1 22.6 0 13.6 7 21 18.5 21 6.6 0 11.3-1.6 15.2-3.9v13c-4.4 1.9-8.9 3.2-17 3.2-21.3 0-32.2-14.3-32.2-33.3zm240.1 0c0-19.1 10.2-34.8 32-34.8 7.9 0 13 1.6 16.4 3v12.6c-3.2-1.9-8.2-3.4-14.8-3.4-11.8 0-18.2 7.8-18.2 22.6 0 13.6 7.1 21 18.6 21 6.6 0 11.3-1.6 15.1-3.9v13c-4.4 1.9-8.8 3.2-16.9 3.2-21.3 0-32.2-14.3-32.2-33.3zm-28.1 32v-65.5h15.1v65.5zm-74.8-65.5h9.4q1.6 0 3.2 0.4 1.6 0.4 3 1.2 1.5 0.8 2.7 1.9 1.2 1.2 2 2.6l18.3 29.3c2.1 3.3 4.5 7.6 5.9 10.6h0.3c-0.2-2.9-0.3-7-0.3-10v-36h13.2v65.5h-16.6l-22.2-35.5c-2-3.2-4.2-7.1-5.7-10.1h-0.3c0.2 2.9 0.4 6.3 0.4 9.4v36.2h-13.3zm-187.8 65.5v-65.5h41v5.9c0 3.5-2.8 6.3-6.3 6.3h-19.6v14.1h22v10.9h-22v16h25.9v12.3zm-45.2 0v-53.3h-17.7v-12.2h50.8v5.8q0 1.3-0.5 2.5-0.5 1.1-1.4 2-0.9 0.9-2 1.4-1.2 0.5-2.5 0.5h-11.5v53.3zm201.3 0v-27.5h-27.6v27.5h-15.1v-65.5h15.1v26.1h27.6v-26.1h15.2v65.5z" }))));
const TTLogoForMobile = (props) => (React__default.createElement("svg", { version: "1.2", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 127 127", ...props },
    React__default.createElement("path", { fillRule: "evenodd", style: { fill: "#fff" }, d: "m70.1 1.1c31.5 3.3 56.1 30 56.1 62.4 0 34.6-28 62.7-62.7 62.7-34.6 0-62.7-28-62.7-62.7 0-34.6 28-62.7 62.7-62.7q3.3 0 6.6 0.3zm3.2 120.7c32.2-5.4 53.9-35.9 48.5-68.1-4.5-26.8-26.3-46.3-52.1-49-5.2-0.6-10.6-0.4-16 0.5-6.4 1-12.4 3.1-17.9 6 28.4 9.7 43.7 24.3 44.7 39.3 0.6 9.3-3.7 16-9.4 21.4l40.2-2.8c1.1-0.1 1.4 1.3 0.1 1.7l-95.8 27.4c9.7 13.5 24.9 22.4 41.7 24.1 5.2 0.6 10.6 0.4 16-0.5zm-26.4-56.9c5.3-19.8-0.7-40.4-15-51.4-19.6 12.3-30.8 35.6-26.7 59.8 1.3 8 4.2 15.4 8.3 21.8 15.2-4.2 28.7-12.3 33.4-30.2z" }),
    React__default.createElement("path", { fillRule: "evenodd", style: { fill: "#c80c0f" }, d: "m121.8 53.7c5.4 32.2-16.3 62.7-48.5 68.1-5.4 0.9-10.8 1.1-16 0.5-16.8-1.7-32-10.6-41.7-24.1l95.8-27.4c1.3-0.4 1-1.8-0.1-1.7l-40.2 2.8c5.7-5.4 10-12.1 9.4-21.4-1-15-16.3-29.6-44.7-39.3 5.5-2.9 11.5-5 17.9-6 5.4-0.9 10.8-1.1 16-0.5 25.8 2.7 47.6 22.2 52.1 49zm-89.9-40.2c14.3 11 20.3 31.6 15 51.4-4.7 17.9-18.2 26-33.4 30.2-4.1-6.4-7-13.8-8.3-21.8-4.1-24.2 7.1-47.5 26.7-59.8z" })));

const useStyles$7 = makeStyles((theme) => ({
    caps: {
        ...theme.typography.button,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(1),
        textAlign: "center",
    },
}));
const TtmsLogin = (props) => {
    const { location: { state: { nextPathname: returnPath = "/", nextSearch: params = "" }, }, } = props;
    const { login } = useTtmsAuth();
    const [error, setError] = useState("");
    const styles = useStyles$7();
    const returnPathWithParams = returnPath + params;
    useEffect(() => {
        login({ returnPath, returnPathWithParams }).catch((e) => setError(e.message));
    }, [login]);
    if (error) {
        return (React__default.createElement(CenteredContent, null,
            React__default.createElement(Error$1, { fontSize: "large" }),
            React__default.createElement("p", { className: styles.caps },
                "Cannot connect to auth server.",
                React__default.createElement("br", null),
                error)));
    }
    return (React__default.createElement(CenteredContent, null,
        React__default.createElement(Box, { position: "relative", display: "inline-flex" },
            React__default.createElement(CircularProgress, { style: { color: "#c80c0f" }, thickness: 1 }),
            React__default.createElement(Box, { top: 0, left: 0, bottom: 0, right: 0, position: "absolute", display: "flex", alignItems: "center", justifyContent: "center" },
                React__default.createElement(TTLogoForMobile, { width: "37" }))),
        React__default.createElement("p", { className: styles.caps }, "Redirecting to login page...")));
};

const useStyles$6 = makeStyles((theme) => createStyles({
    small: {
        width: theme.spacing(3.5),
        height: theme.spacing(3.5),
    },
}));
const TtmsTopMenu = (props) => {
    const { isAuthorized } = useTtmsAuth();
    const authProvider = useAuthProvider();
    const { loaded, authenticated } = useAuthState();
    return isAuthorized || (loaded && authenticated && authProvider) ? React__default.createElement(LoggedInTopMenu, { ...props }) : React__default.createElement(LoginButton, null);
};
const LoggedInTopMenu = (props) => {
    const { children, label = "ra.auth.user_menu", icon = React__default.createElement(AccountCircle, null) } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const theme = useTheme();
    const isMedium = useMediaQuery(theme.breakpoints.down("sm"));
    const isSmall = useMediaQuery(theme.breakpoints.down("xs"));
    const translate = useTranslate();
    const { user: ttmsUser, logout: ttmsLogout } = useTtmsAuth();
    const customAuthlogout = useLogout();
    const { identity: customAuthUser, loaded: customAuthLoaded } = useGetIdentity();
    let userText = "";
    if (ttmsUser) {
        if (isMedium && (ttmsUser === null || ttmsUser === void 0 ? void 0 : ttmsUser.firstName)) {
            const first = ttmsUser.firstName.substring(0, 1);
            const last = ttmsUser.lastName.substring(0, 1);
            userText = `${first}. ${last}.`;
        }
        else if (ttmsUser === null || ttmsUser === void 0 ? void 0 : ttmsUser.fullName) {
            userText = ttmsUser.fullName;
        }
    }
    else if (customAuthLoaded && customAuthUser) {
        userText = customAuthUser.fullName;
    }
    if (isSmall) {
        // @ts-ignore
        userText = null;
    }
    if (!ttmsLogout && !children)
        return null;
    const open = Boolean(anchorEl);
    const handleMenu = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    return (React__default.createElement("div", null,
        React__default.createElement(Tooltip, { title: label && translate(label, { _: label }) },
            React__default.createElement(Button, { endIcon: React__default.createElement(UserImage, null), "aria-label": label && translate(label, { _: label }), "aria-haspopup": true, color: "inherit", onClick: handleMenu }, userText)),
        React__default.createElement(Menu, { id: "menu-appbar", anchorEl: anchorEl, anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
            }, transformOrigin: {
                vertical: "top",
                horizontal: "center",
            }, open: open, onClose: handleClose },
            Children.map(children, (menuItem) => isValidElement(menuItem)
                ? cloneElement(menuItem, {
                    onClick: handleClose,
                })
                : null),
            React__default.createElement(MenuItem, { onClick: ttmsUser ? ttmsLogout : customAuthlogout },
                React__default.createElement(ExitToApp, null),
                " Log out"))));
};
const LoginButton = (props) => {
    const { login: ttmsLogin } = useTtmsAuth();
    const loginClick = () => {
        store === null || store === void 0 ? void 0 : store.dispatch(changeAllowAnonymous(false));
        ttmsLogin({});
    };
    return (React__default.createElement(Tooltip, { title: "Login" },
        React__default.createElement(Button, { endIcon: React__default.createElement(AccountCircle, null), "aria-haspopup": true, color: "inherit", onClick: loginClick }, "Login")));
};
const UserImage = (props) => {
    const classes = useStyles$6();
    const { user: { userPhoto }, authService: { isAuthenticated }, } = useTtmsAuth();
    if (!isAuthenticated || !userPhoto) {
        return React__default.createElement(AccountCircle, null);
    }
    return React__default.createElement(Avatar, { className: classes.small, src: `data:image/jpeg;base64,${userPhoto}` });
};

/** Default user type(customer) filter */
const customerFilter = ({ menu, user }) => menu.filter((menuItem) => ((user === null || user === void 0 ? void 0 : user.isCustomer) ? menuItem.isVisibleForCustomer : true));
/** Default permission control filter */
const permissionFilter = ({ menu, user }) => menu.filter((menuItem) => (user && menuItem.permissions ? menuItem.permissions.some((p) => user.hasPermission(p)) : true));
/** Default anonymous control filter */
const anonymousFilter = ({ menu, user }) => menu.filter((menuItem) => (!user ? menuItem.isVisibleForAnonymous : true));
const TtmsMenuContext = createContext({ menuFilters: [], disableDefaultFilters: false });
const useTtmsMenu = () => useContext(TtmsMenuContext);
const TtmsMenuContextProvider = ({ children, menuFilters, disableDefaultFilters }) => {
    let filters = disableDefaultFilters ? [...menuFilters] : [permissionFilter, customerFilter, anonymousFilter, ...menuFilters];
    return React__default.createElement(TtmsMenuContext.Provider, { value: { menuFilters: filters, disableDefaultFilters } }, children);
};

const useMenuIsActive = (menuPath) => {
    const { pathname } = useLocation();
    let locationPath = pathname;
    if (!menuPath) {
        return false;
    }
    if (locationPath.charAt(0) === "/") {
        locationPath = locationPath.substring(1);
    }
    if (locationPath.includes("/")) {
        locationPath = locationPath.split("/")[0];
    }
    if (locationPath.includes("?")) {
        locationPath = locationPath.split("?")[0];
    }
    menuPath = menuPath.charAt(0) === "/" ? menuPath.substring(1) : menuPath;
    return menuPath === locationPath;
};

const FontIcon = ({ children }) => React__default.createElement(Icon, null, children);
const useMenuStyles = makeStyles((theme) => ({
    menu: {
        paddingTop: theme.spacing(2),
        width: "240px",
    },
}));
const useStyles$5 = makeStyles((theme) => createStyles({
    active: {
        borderLeft: "4px solid #c80c0f",
        color: "rgba(0, 0, 0, 0.87)",
        "& .MuiListItemIcon-root": {
            color: "#c80c0f",
        },
    },
    passive: {
        borderLeft: "4px solid #fafafa",
    },
    menuItemIcon: {
        minWidth: "40px",
    },
    sidebarIsOpen: (level) => ({
        "& a": {
            paddingLeft: level * 37 - (level >= 2 ? theme.spacing(2) : 0) - 4,
            transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
        },
        "& li": {
            paddingLeft: level * 37 - (level >= 2 ? theme.spacing(2) : 0) - 4,
            transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
        },
    }),
    sidebarIsClosed: () => ({
        "& a": {
            paddingLeft: theme.spacing(2),
            transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
        },
        "& li": {
            paddingLeft: theme.spacing(2),
            transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
        },
    }),
}));
const menuFilterRunner = ({ menu, user, filterFunc }) => {
    let result = [];
    menu = filterFunc({ menu, user });
    menu.forEach((menuItem) => {
        let tempMenuChildren = [], tempMenuItem;
        if (menuItem.children && Array.isArray(menuItem.children)) {
            tempMenuChildren = menuFilterRunner({ menu: menuItem.children, user: user, filterFunc: filterFunc });
            tempMenuItem = { ...menuItem, children: tempMenuChildren };
        }
        else {
            tempMenuItem = { ...menuItem };
        }
        if (tempMenuItem) {
            result.push(tempMenuItem);
        }
    });
    return result;
};
const TtmsMenu = React__default.memo(({ onMenuClick, dense }) => {
    const classes = useMenuStyles();
    const open = useSelector((state) => state.admin.ui.sidebarOpen);
    let { menu: menuItems } = useTtmsAppConfig();
    const { user } = useTtmsAuth();
    const { menuFilters } = useTtmsMenu();
    const filteredMenuItems = useMemo(() => {
        //filter menu items.
        menuFilters.forEach((menuFilter) => {
            menuItems = menuFilterRunner({ menu: menuItems, user: user, filterFunc: menuFilter });
        });
        //log filtred menu items
        if (process.env.NODE_ENV === "development") {
            console.groupCollapsed("Menu Items(Filtered)");
            console.info({ menuItems });
            console.groupEnd();
        }
        return menuItems;
    }, [menuFilters]);
    let level = 0;
    const RenderMenuItemLink = React__default.memo((item) => {
        const { text, path, icon: iconName } = item;
        const icon = iconName ? React__default.createElement(FontIcon, null, iconName) : React__default.createElement(FiberManualRecord, null);
        const isActive = useMenuIsActive(path);
        const classes = useStyles$5(isActive);
        return (React__default.createElement(MenuItemLink, { to: path, key: path, primaryText: text, onClick: onMenuClick, sidebarIsOpen: open, leftIcon: icon, dense: dense, activeClassName: classes.active, className: isActive ? classes.active : classes.passive }));
    });
    const RenderSubMenuItem = React__default.memo(({ menuItem }) => {
        const { text, icon: iconName, children } = menuItem;
        const icon = iconName ? React__default.createElement(FontIcon, null, iconName) : React__default.createElement(FiberManualRecord, null);
        if (!children) {
            return React__default.createElement(RenderMenuItemLink, { ...menuItem });
        }
        if (level !== 2) {
            level++;
        }
        const hasChildrenIsActive = children.some((item) => useMenuIsActive(item.path));
        return (React__default.createElement(SubMenu, { sidebarIsOpen: open, key: menuItem.text, level: level, icon: icon, name: text, dense: dense, isOpen: menuItem.isOpen || hasChildrenIsActive }, children.map((c, index) => {
            var _a;
            if (((_a = c.children) === null || _a === void 0 ? void 0 : _a.length) < 1) {
                return React__default.createElement(RenderMenuItemLink, { key: c.text, ...c, icon: c.icon ? c.icon : menuItem.icon }); //renderMenuItemLink({ ...c, icon: c.icon ? c.icon : menuItem.icon });
            }
            else {
                return React__default.createElement(RenderSubMenuItem, { key: c.text, menuItem: c }); //renderSubMenuItem(c, key);
            }
        })));
    });
    if (menuItems.length < 1) {
        return null;
    }
    return (React__default.createElement("div", { className: classes.menu }, filteredMenuItems.map((menuItem, index) => {
        var _a;
        if (((_a = menuItem.children) === null || _a === void 0 ? void 0 : _a.length) < 1) {
            level = 0;
            return React__default.createElement(RenderMenuItemLink, { key: menuItem.text, ...menuItem }); //renderMenuItemLink(menuItem);
        }
        return React__default.createElement(RenderSubMenuItem, { key: menuItem.text, menuItem: menuItem }); //renderSubMenuItem(menuItem, index);
    })));
});
const SubMenu = React__default.memo(({ sidebarIsOpen, isOpen: isOpenByDefault, name, icon, children, dense, level }) => {
    const classes = useStyles$5(level);
    const [isOpen, setIsOpen] = useState(!!isOpenByDefault);
    const header = (React__default.createElement(MenuItem, { dense: dense, className: classes.passive, button: true, onClick: () => setIsOpen(!isOpen) },
        React__default.createElement(ListItemIcon, { className: classes.menuItemIcon }, icon),
        React__default.createElement(Typography, { variant: "inherit", color: "textSecondary", style: { flex: "1 1 auto" } }, name),
        !isOpen ? React__default.createElement(IconExpandMore, null) : React__default.createElement(IconExpandLess, null)));
    return (React__default.createElement(Fragment, null,
        sidebarIsOpen || isOpen ? (header) : (React__default.createElement(Tooltip, { title: name, placement: "right" }, header)),
        React__default.createElement(Collapse, { in: isOpen, timeout: "auto", unmountOnExit: true },
            React__default.createElement(Divider, null),
            React__default.createElement(List, { dense: dense, component: "div", disablePadding: true, className: sidebarIsOpen ? classes.sidebarIsOpen : classes.sidebarIsClosed }, children))));
});

/**
 * The AppBar component renders a custom MuiAppBar.
 *
 * @param {Object} props
 * @param {ReactNode} props.children React node/s to be render as children of the AppBar
 * @param {Object} props.classes CSS class names
 * @param {string} props.className CSS class applied to the MuiAppBar component
 * @param {string} props.color The color of the AppBar
 * @param {Component} props.logout The logout button component that will be pass to the UserMenu component
 * @param {boolean} props.open State of the <Admin/> Sidebar
 * @param {Element | boolean} props.userMenu A custom user menu component for the AppBar. <UserMenu/> component by default. Pass false to disable.
 *
 * @example
 *
 * const MyAppBar = props => {
 *   const classes = useStyles();
 *   return (
 *       <AppBar {...props}>
 *           <Typography
 *               variant="h6"
 *               color="inherit"
 *               className={classes.title}
 *               id="react-admin-title"
 *           />
 *       </AppBar>
 *   );
 *};
 *
 * @example Without a user menu
 *
 * const MyAppBar = props => {
 *   const classes = useStyles();
 *   return (
 *       <AppBar {...props} userMenu={false} />
 *   );
 *};
 */
const TtmsNavBar = (props) => {
    const { children, classes: classesOverride, className, color = "secondary", logout, open, title, userMenu, container: Container, ...rest } = props;
    const classes = useStyles$4(props);
    const sidebarToggleButtonClasses = {
        menuButtonIconClosed: classes.menuButtonIconClosed,
        menuButtonIconOpen: classes.menuButtonIconOpen,
    };
    const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
    const { menu, sideBarDefaultOpen } = useTtmsAppConfig();
    const hasMenuItems = menu && menu.length > 0;
    const dispatch = useDispatch();
    useEffect(() => {
        if (!hasMenuItems) {
            dispatch(setSidebarVisibility(false));
        }
        else {
            dispatch(setSidebarVisibility(sideBarDefaultOpen));
        }
    }, []);
    return (React.createElement(Container, null,
        React.createElement(AppBar, { className: className, color: color, ...rest },
            React.createElement(Toolbar, { disableGutters: true, variant: isXSmall ? "regular" : "dense", className: classes.toolbar },
                hasMenuItems ? (React.createElement(SidebarToggleButton, { className: classes.menuButton, classes: sidebarToggleButtonClasses })) : (React.createElement(Box, { ml: 1.5, mr: 1.5 })),
                Children.count(children) === 0 ? (React.createElement(Typography, { variant: "h6", color: "inherit", className: classes.title, id: "react-admin-title" })) : (children),
                React.createElement(LoadingIndicator, null),
                typeof userMenu === "boolean" ? (userMenu === true ? (React.createElement(UserMenu, { logout: logout })) : null) : (cloneElement(userMenu, { logout }))))));
};
TtmsNavBar.propTypes = {
    children: PropTypes.node,
    // @ts-ignore
    classes: PropTypes.object,
    className: PropTypes.string,
    color: PropTypes.oneOf(["default", "inherit", "primary", "secondary", "transparent"]),
    container: ComponentPropType,
    logout: PropTypes.element,
    // @deprecated
    open: PropTypes.bool,
    userMenu: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
};
TtmsNavBar.defaultProps = {
    userMenu: React.createElement(UserMenu, null),
    container: HideOnScroll,
};
const useStyles$4 = makeStyles$1((theme) => ({
    toolbar: {
        paddingRight: 24,
    },
    menuButton: {
        marginLeft: "0.2em",
        marginRight: "0.2em",
    },
    menuButtonIconClosed: {},
    menuButtonIconOpen: {},
    title: {
        flex: 1,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
    },
}), { name: "RaAppBar" });
var TtmsNavbar = memo(TtmsNavBar);

const useStyles$3 = makeStyles((theme) => ({
    spacer: {
        flex: 1,
    },
    appTitle: {
        marginRight: "0.5rem",
        fontWeight: "bold",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        "&::before": {
            content: '" "',
            width: "1px",
            borderLeft: "2px solid #ededed",
            boxShadow: "1px 0px 1px #9b9b9b",
            marginRight: "0.8rem",
            height: "32px",
        },
    },
    layoutTitle: {
        marginTop: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            paddingLeft: theme.spacing(2),
        },
    },
}));
const TtmsAppBar = (props) => {
    const classes = useStyles$3();
    const { appTitle, navbar } = useTtmsAppConfig();
    // @ts-ignore
    let userMenu = React__default.createElement(TtmsTopMenu, null);
    return (React__default.createElement(TtmsNavbar, { elevation: 2, userMenu: userMenu, ...props },
        React__default.createElement("div", null, React__default.cloneElement(navbar.appLogo)),
        navbar.showAppTitle && (React__default.createElement(Typography, { variant: "h6", color: "inherit", className: classes.appTitle }, appTitle)),
        React__default.createElement("span", { className: classes.spacer }),
        navbar.additionalItems.map((c) => React__default.cloneElement(c))));
};
const TtmsLayout = (props) => {
    const { menu } = useTtmsAppConfig();
    const styles = useStyles$3();
    return (React__default.createElement(Layout, { ...props, menu: menu ? TtmsMenu : undefined, appBar: TtmsAppBar, sidebar: menu.length < 1 ? EmptySidebar : undefined },
        React__default.createElement(Typography, { variant: "h6", color: "inherit", id: "react-admin-title", className: styles.layoutTitle }),
        props.children));
};
const EmptySidebar = () => {
    return React__default.createElement(Box, { mr: 3 });
};

const ttmsAdminTheme = createTheme({
    palette: {
        primary: {
            main: "#C90C0F",
        },
        secondary: {
            main: "#FFFFFF",
        },
    },
    typography: {
        fontFamily: [
            "Geologica",
            "-apple-system",
            "BlinkMacSystemFont",
            "Segoe UI",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            "Apple Color Emoji",
            "Segoe UI Emoji",
            "Segoe UI Symbol",
        ].join(","),
        h6: {
            fontSize: "1em",
        },
    },
    overrides: {
        MuiButton: {
            textPrimary: {
                color: "#C90C0F",
            },
        },
    }
});

/**
 *
 * @param title
 *
 * @example
 *
 *  import {useTTDocumentTitle} from "@tt/ttms-react-core";
 *
 *  const ProductList: FC<ListProps> = (props) => {
 *
 *  useTTDocumentTitle("Product List"); // Product List - Demo App
 *
 *  return (
 *       <List {...props} >
 *       <Datagrid>
 *           <TextField source="name">
 *           <NumberField source="quantity">
 *           ...
 *       </Datagrid>
 *       </List>
 *   );
 *  };
 *
 */
const useTTDocumentTitle = (title) => {
    const config = useTtmsAppConfig();
    if (title.indexOf(config.appTitle) < 0) {
        title = `${title} - ${config.appTitle}`;
    }
    useEffect(() => {
        document.title = title;
    }, [title]);
};

const UPLOAD_PROGRESS = "upload_progress";
const initialState = {};
function uploadsReducer(state = initialState, action) {
    switch (action.type) {
        case UPLOAD_PROGRESS:
            return {
                ...state,
                [action.name]: action.fraction,
            };
        case CRUD_CREATE_SUCCESS:
        case CRUD_CREATE_FAILURE:
        case CRUD_UPDATE_FAILURE:
        case CRUD_UPDATE_SUCCESS:
            return initialState;
        default:
            return state;
    }
}
function uploadProgress(name, fraction) {
    return {
        type: UPLOAD_PROGRESS,
        name,
        fraction,
    };
}

const useHasAccess = (resource, action = undefined) => {
    const { user } = useTtmsAuth();
    const { accessControl } = useTtmsAppConfig();
    const hasAccess = (resource, action) => {
        var _a;
        return (_a = user === null || user === void 0 ? void 0 : user.roles) === null || _a === void 0 ? void 0 : _a.some((role) => {
            var _a;
            if (resource == undefined) {
                return false;
            }
            const rolePolicy = accessControl[role];
            if (typeof rolePolicy === "boolean") {
                // bulk assignment control for role
                return rolePolicy;
            }
            if (!rolePolicy) {
                return false;
            }
            const resourcePolicy = rolePolicy[resource];
            if (typeof resourcePolicy === "boolean") {
                // bulk assignment control for resource
                return resourcePolicy;
            }
            return (_a = resourcePolicy === null || resourcePolicy === void 0 ? void 0 : resourcePolicy[action]) !== null && _a !== void 0 ? _a : false;
        });
    };
    return {
        hasAccess,
        canCreate: hasAccess(resource, "create"),
        canEdit: hasAccess(resource, "edit"),
        canList: hasAccess(resource, "list"),
        canShow: hasAccess(resource, "show"),
        canPerform: hasAccess(resource, action),
    };
};

const useVerifyPermission = (resource, action) => {
    const { canPerform } = useHasAccess(resource, action);
    const redirect = useRedirect();
    useEffect(() => {
        if (!canPerform) {
            redirect("/unauthorized");
        }
    }, [resource, action, redirect]);
};

const useStyles$2 = makeStyles$1((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        [theme.breakpoints.up("md")]: {
            height: "100%",
        },
        [theme.breakpoints.down("sm")]: {
            height: "100vh",
            marginTop: "-3em",
        },
    },
    icon: {
        width: "9em",
        height: "9em",
    },
    message: {
        textAlign: "center",
        fontFamily: "Roboto, sans-serif",
        opacity: 0.5,
        margin: "0 1em",
    },
    toolbar: {
        textAlign: "center",
        marginTop: "2em",
    },
}), { name: "RaUnAuthorize" });
function goBack() {
    window.history.go(-1);
}
const Unauthorized = (props) => {
    const classes = useStyles$2();
    const history = useHistory();
    function goHome() {
        history.push("/");
    }
    return (React__default.createElement("div", { className: classes.container },
        React__default.createElement("div", { className: classes.message },
            React__default.createElement(BlockIcon, { className: classes.icon }),
            React__default.createElement("h1", null, "Access denied!"),
            React__default.createElement("div", null, "You don't have permissions to access this page.")),
        React__default.createElement("div", { className: classes.toolbar },
            React__default.createElement(Button$1, { variant: "contained", startIcon: React__default.createElement(History, null), onClick: goBack, label: "Go Back" }),
            React__default.createElement(Button$1, { variant: "contained", color: "secondary", startIcon: React__default.createElement(Home, null), onClick: goHome, style: { marginLeft: "5px" }, label: "Go Home" }))));
};

const RestrictedRoute = (props) => {
    const { path, component } = props;
    let routePath = path;
    routePath = routePath.includes("/") ? routePath.substring(1) : routePath;
    const { canPerform } = useHasAccess(routePath);
    return React__default.createElement(Route, { ...props, component: canPerform ? component : Unauthorized });
};

const RestrictedResource = (props) => {
    const { name, list, create, show, edit, unAuthorizedElement } = props;
    const acl = useHasAccess(name);
    return (React__default.createElement(Resource, { ...props, list: acl.canList ? list : unAuthorizedElement, create: acl.canCreate ? create : unAuthorizedElement, edit: acl.canEdit ? edit : unAuthorizedElement, show: acl.canShow ? show : unAuthorizedElement }));
};
RestrictedResource.defaultProps = {
    unAuthorizedElement: Unauthorized,
};

/** You can perform access control with RestrictedComponent for any react component
 *
 * Props:
 *  - restrictionProps
 *  - action
 *  - resource
 *
 * @example Access control for button
 *
 *          <RestrictedComponent
 *               action="send"
 *               resource="emails"
 *               restrictionProps={{ disabled: true }}>
 *                  <Button onClick={sendEmail} label="Button" />
 *          </RestrictedComponent>
 *
 * @example Toolbar button permission control
 *
 * const ListActions = () => (
 *          <TopToolbar>
 *               <SortButton fields={['reference', 'sales', 'stock']} />
 *               <RestrictedComponent
 *                   resource="products"
 *                   restrictionProps={{ disabled: true }}>
 *                   <CreateButton basePath="/products" />
 *                   <ExportButton />
 *               </RestrictedComponent>
 *           </TopToolbar>
 *  );
 *
 * @example List access control
 *
 *          <RestrictedComponent action="list" resource="customers">
 *             <TTList resource="customers" filters={<CustomerFilter />}>
 *               <Datagrid>
 *                 <TextField source="firstName" />
 *                 <TextField source="lastName" />
 *               </Datagrid>
 *             </TTList>
 *          </RestrictedComponent>
 *
 */
const RestrictedComponent = ({ children, restrictionProps, action, resource, }) => {
    const { canPerform } = useHasAccess(resource, action);
    if (canPerform) {
        return React__default.createElement(React__default.Fragment, null,
            " ",
            children,
            " ");
    }
    if (restrictionProps === undefined) {
        return null;
    }
    const mutated = React__default.Children.map(children, (c, _) => {
        if (React__default.isValidElement(c)) {
            return React__default.cloneElement(c, restrictionProps);
        }
        return c;
    });
    return React__default.createElement(React__default.Fragment, null, mutated);
};

const defaultI18nProvider = polyglotI18nProvider((locale) => defaultMessages, undefined, {
    allowMissing: true,
    onMissingKey: (key, options) => key,
});
let store;
const TtmsApp = ({ config, children, customReducers, customSagas, dataProvider, authProvider, i18nProvider, initialState, menuFilters = [], disableDefaultMenuFilters = false, transformUser, navbar, allowAnonymous = false, sideBarDefaultOpen = true, ...rest }) => {
    if (!dataProvider) {
        throw new Error(`Missing dataProvider prop.
React-admin requires a valid dataProvider function to work.`);
    }
    const defaultNavbarValues = { appLogo: React.createElement(TTLogo, null), additionalItems: [], showAppTitle: true };
    useEffect(() => {
        // @ts-ignore
        console.log("@tt/ttms-react-core", "version:", "1.23.0");
    }, []);
    const finalAuthProvider = authProvider !== null && authProvider !== void 0 ? authProvider : undefined;
    const finalDataProvider = dataProvider;
    const finalHistory = createHashHistory();
    const finalI18nProvider = (i18nProvider || defaultI18nProvider);
    store = createAdminStore({
        authProvider: finalAuthProvider,
        customReducers: {
            ...customReducers,
            uploads: uploadsReducer,
            allowAnonymous: allowAnonymousReducer,
        },
        customSagas,
        dataProvider: finalDataProvider,
        initialState,
        history: finalHistory,
    });
    if (config.apiBaseUrl === undefined) {
        config.apiBaseUrl = finalDataProvider.baseUrl;
    }
    config.navbar = { ...defaultNavbarValues, ...navbar };
    config.sideBarDefaultOpen = sideBarDefaultOpen;
    return (React.createElement(Provider, { store: store },
        React.createElement(TtmsAppConfigProvider, { config: config },
            React.createElement(TtmsMenuContextProvider, { menuFilters: menuFilters, disableDefaultFilters: disableDefaultMenuFilters },
                React.createElement(TtmsAuthProvider, { config: config.auth, transformUser: transformUser, allowAnonymous: allowAnonymous },
                    React.createElement(AdminWithTtmsAuth, { dataProvider: finalDataProvider, authProvider: finalAuthProvider, history: finalHistory, i18nProvider: finalI18nProvider, ...rest }, children))))));
};
const AdminWithTtmsAuth = (props) => {
    const { loading: authLoading, authService, errors, allowAnonymous } = useTtmsAuth();
    const [allowAnonymousState, setAllowAnonymousState] = useState(allowAnonymous);
    useEffect(() => {
        store.subscribe(() => {
            setAllowAnonymousState(allowAnonymousSelector(store.getState()));
        });
    }, []);
    const stubAuthProvider = createTtmsAuthProvider(authService);
    if (errors.length > 0) {
        return (React.createElement(CenteredContent, null,
            React.createElement(Alert, { severity: "error" },
                "Failed to authorize.",
                errors.map((e) => (React.createElement("p", { key: e }, e))))));
    }
    if (authLoading) {
        return (React.createElement(CenteredContent, null,
            React.createElement(Box, { position: "relative", display: "inline-flex" },
                React.createElement(CircularProgress, { style: { color: "#c80c0f" }, thickness: 1 }),
                React.createElement(Box, { top: 0, left: 0, bottom: 0, right: 0, position: "absolute", display: "flex", alignItems: "center", justifyContent: "center" },
                    React.createElement(TTLogoForMobile, { width: "37" })))));
    }
    // pluck overridden properties out
    const { theme, loginPage = Login, layout, authProvider: customAuthProvider, children, customRoutes = [], ...adminProps } = props;
    return (React.createElement(Admin, { disableTelemetry: true, theme: ttmsAdminTheme, loginPage: customAuthProvider ? loginPage : TtmsLogin, layout: TtmsLayout, authProvider: !allowAnonymousState ? customAuthProvider !== null && customAuthProvider !== void 0 ? customAuthProvider : stubAuthProvider : null, customRoutes: [React.createElement(Route, { exact: true, path: "/unauthorized", component: Unauthorized }), ...customRoutes], ...adminProps }, children));
};

const initAxiosInterceptors = (instance = axios) => {
    instance.interceptors.request.use(value => {
        const existingAuth = value.headers["Authorization"];
        if (existingAuth !== undefined) {
            return value;
        }
        const token = localStorage.getItem("token");
        value.headers["Authorization"] = "Bearer " + token;
        return value;
    });
    instance.interceptors.response.use(value => {
        if ([401, 403].includes(value.status)) {
            console.log("axios auth error", value.status);
            // window.location.hash = '#/login';
        }
        return value;
    });
};
const createAxios = (config) => {
    const instance = axios.create(config);
    initAxiosInterceptors(instance);
    return instance;
};

const useMinio = () => {
    const { apiBaseUrl } = useTtmsAppConfig();
    const { tokens, isAuthorized } = useTtmsAuth();
    const { loaded, authenticated } = useAuthState();
    const convertUrl = (objectKey, bucketUrl) => {
        if (typeof objectKey !== "string") {
            if (process.env.NODE_ENV === "development") {
                console.warn(`Cannot generate MinIO URL. ${objectKey} is not a string`);
            }
            return null;
        }
        // already converted?
        if (/^https?:/.test(objectKey))
            return objectKey;
        // objectKeys must be in $bucket/$objectName format
        if (!objectKey.includes("/"))
            return objectKey;
        if (bucketUrl) {
            return `${bucketUrl}/${objectKey}`;
        }
        return isAuthorized || (loaded && authenticated)
            ? `${apiBaseUrl}/minio/${objectKey}?token=${tokens === null || tokens === void 0 ? void 0 : tokens.accessToken}`
            : `${apiBaseUrl}/minio/${objectKey}`;
    };
    return {
        convertUrl,
    };
};

const MinioField = (props) => {
    const minio = useMinio();
    let { record, source, src = "url", bucketUrl } = props;
    record = cloneDeep(record);
    const sourceValue = get(record, source);
    if (typeof sourceValue === "string") {
        set(record, source, minio.convertUrl(sourceValue, bucketUrl));
    }
    else if (Array.isArray(sourceValue)) {
        set(record, source, sourceValue.map((it) => {
            if (typeof it === "string")
                return { [src]: minio.convertUrl(it, bucketUrl), objectKey: it };
            const objectKey = get(it, src, it);
            return { objectKey, ...it, [src]: minio.convertUrl(objectKey, bucketUrl) };
        }));
    }
    return (React__default.createElement(React__default.Fragment, null, React__default.Children.map(props.children, (c) => React__default.cloneElement(c, { ...props, record }))));
};

const useStyles$1 = makeStyles((theme) => ({
    previewList: {
        display: "flex",
        alignItems: "stretch",
    },
    previewCard: {
        position: "relative",
        // padding: theme.spacing(2),
        minHeight: theme.spacing(10),
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        maxWidth: "300px",
        "&:hover $removeButton": {
            opacity: 1,
            transform: "scale(1)",
        },
    },
    removeButton: {
        position: "absolute",
        right: theme.spacing(2),
        top: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows["1"],
        opacity: 0,
        transform: "scale(0.75)",
        transition: "0.2s",
        "&:hover": {
            backgroundColor: theme.palette.background.paper,
        },
    },
    removeIcon: {
        color: theme.palette.error.main,
    },
    downloadButton: {
        marginRight: theme.spacing(2),
    },
    fileCard: {
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        padding: theme.spacing(2),
        maxWidth: "300px",
        textOverflow: "ellipsis",
    },
    filename: {
        wordBreak: "break-all",
    },
}));
const MinioFileInput = (props) => {
    const { accept, children, className, classes: classesOverride, 
    // format,
    helperText, label, labelMultiple = "ra.input.file.upload_several", labelSingle = "ra.input.file.upload_single", maxSize, minSize, multiple = false, options: { inputProps: inputPropsOptions, ...options } = {}, 
    // parse,
    placeholder, preview, resource, source, validate, bucketUrl, ...rest } = props;
    const translate = useTranslate$1();
    const classes = useStyles$1(props);
    const format = (v) => {
        if (typeof v === "string") {
            // already uploaded, we hae objectKey
            return v;
        }
        if (v instanceof File) {
            // let downstream handle files
            return v;
        }
        return v;
    };
    const parse = (v) => format(v);
    const { id, input: { onChange, value, ...inputProps }, meta, isRequired, } = useInput({
        // format: format || transformFiles,
        // parse: parse || transformFiles,
        format,
        parse,
        source,
        type: "file",
        validate,
        ...rest,
    });
    const { touched, error } = meta;
    const files = value ? (Array.isArray(value) ? value : [value]) : [];
    const onDrop = (newFiles, rejectedFiles, event) => {
        let updatedFiles = multiple ? [...files, ...newFiles] : [...newFiles];
        updatedFiles = updatedFiles.map(format);
        if (multiple) {
            onChange(updatedFiles);
        }
        else {
            onChange(updatedFiles[0]);
        }
    };
    const onRemove = (file) => () => {
        if (multiple) {
            const filteredFiles = files.filter((stateFile) => !shallowEqual(stateFile, file));
            onChange(filteredFiles);
        }
        else {
            onChange(null);
        }
    };
    const { getRootProps, getInputProps } = useDropzone({
        ...options,
        accept,
        maxSize,
        minSize,
        multiple,
        onDrop,
    });
    return (React.createElement(Labeled, { id: id, label: label, source: source, resource: resource, isRequired: isRequired, meta: meta },
        React.createElement(React.Fragment, null,
            React.createElement("div", { ...getRootProps() },
                React.createElement("input", { id: id, ...getInputProps({
                        ...inputProps,
                        ...inputPropsOptions,
                    }) }),
                placeholder ? placeholder : multiple ? React.createElement("p", null, translate(labelMultiple)) : React.createElement("p", null, translate(labelSingle))),
            React.createElement(FormHelperText, null,
                React.createElement(InputHelperText, { touched: touched, error: error, helperText: helperText })),
            React.createElement("div", { className: classes.previewList }, files.map((f, i) => (React.createElement(MinioFilePreview, { file: f, onRemove: onRemove(f), key: i },
                React.createElement(MinioFileField$1, { ...props, file: f }))))))));
};
function MinioFilePreview(props) {
    const classes = useStyles$1();
    const uploads = useSelector((state) => state.uploads); // DefaultRootState'de uploads property'si olmadığı için hata veriyordu. Çözüm için any'e cast edildi.
    const { onRemove, file } = props;
    let progress;
    if (file instanceof File && uploads[file.name]) {
        progress = Math.min(100, uploads[file.name] * 100);
    }
    return (React.createElement("div", { className: classes.previewCard },
        props.children,
        progress && React.createElement(LinearProgress, { variant: "determinate", value: progress }),
        !progress && (React.createElement(IconButton, { onClick: onRemove, className: classes.removeButton },
            React.createElement(Delete, { className: classes.removeIcon })))));
}
function MinioFileField$1(props) {
    const minio = useMinio();
    let { file, bucketUrl } = props;
    let objectKey = "";
    if (typeof file === "string") {
        objectKey = file;
    }
    let url = "";
    if (objectKey) {
        url = minio.convertUrl(objectKey, bucketUrl);
    }
    let filename = "";
    if (file instanceof File) {
        filename = file.name;
    }
    else if (objectKey) {
        filename = objectKey.split("/").pop();
    }
    return React.createElement(FileCard, { filename: filename, url: url });
}
function FileCard(props) {
    const { filename, url } = props;
    const classes = useStyles$1();
    const canDownload = !!url;
    return (React.createElement(Paper, { className: classes.fileCard },
        canDownload && (React.createElement(IconButton, { className: classes.downloadButton, component: "a", href: url, target: "_blank", download: true },
            React.createElement(CloudDownload, { color: "primary" }))),
        !canDownload && (React.createElement(IconButton, { className: classes.downloadButton, disabled: true },
            React.createElement(CloudUpload, null))),
        " ",
        React.createElement("span", { className: classes.filename }, filename)));
}

const useStyles = makeStyles((theme) => ({
    previewList: {
        display: "flex",
        alignItems: "flex-start",
    },
    previewCard: {
        display: "inline-flex",
        position: "relative",
        // padding: theme.spacing(2),
        minHeight: theme.spacing(10),
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        maxWidth: "300px",
        "&:hover $removeButton": {
            opacity: 1,
            transform: "scale(1)",
        },
    },
    removeButton: {
        position: "absolute",
        right: theme.spacing(2),
        top: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows["1"],
        opacity: 0,
        transform: "scale(0.75)",
        transition: "0.2s",
        "&:hover": {
            backgroundColor: theme.palette.background.paper,
        },
    },
    removeIcon: {
        color: theme.palette.error.main,
    },
    downloadButton: {
        marginRight: theme.spacing(2),
    },
    fileCard: {
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        maxWidth: "300px",
    },
    filename: {
        wordBreak: "break-all",
    },
    image: {
        display: "block",
        width: "100%",
        height: "auto",
    },
}));
const MinioImageInput = (props) => {
    const { accept, children, className, classes: classesOverride, 
    // format,
    helperText, label, labelMultiple = "ra.input.file.upload_several", labelSingle = "ra.input.file.upload_single", maxSize, minSize, multiple = false, options: { inputProps: inputPropsOptions, ...options } = {}, 
    // parse,
    placeholder, preview, resource, source, validate, bucketUrl, ...rest } = props;
    const translate = useTranslate$1();
    const classes = useStyles(props);
    const format = (v) => {
        if (typeof v === "string") {
            // already uploaded, we hae objectKey
            return v;
        }
        if (v instanceof File) {
            // let downstream handle files
            return v;
        }
        return v;
    };
    const parse = (v) => format(v);
    const { id, input: { onChange, value, ...inputProps }, meta, isRequired, } = useInput({
        // format: format || transformFiles,
        // parse: parse || transformFiles,
        format,
        parse,
        source,
        type: "file",
        validate,
        ...rest,
    });
    const { touched, error } = meta;
    const files = value ? (Array.isArray(value) ? value : [value]) : [];
    const onDrop = (newFiles, rejectedFiles, event) => {
        let updatedFiles = multiple ? [...files, ...newFiles] : [...newFiles];
        updatedFiles = updatedFiles.map(format);
        if (multiple) {
            onChange(updatedFiles);
        }
        else {
            onChange(updatedFiles[0]);
        }
    };
    const onRemove = (file) => () => {
        if (multiple) {
            const filteredFiles = files.filter((stateFile) => !shallowEqual(stateFile, file));
            onChange(filteredFiles);
        }
        else {
            onChange(null);
        }
    };
    const { getRootProps, getInputProps } = useDropzone({
        ...options,
        accept,
        maxSize,
        minSize,
        multiple,
        onDrop,
    });
    return (React.createElement(Labeled, { id: id, label: label, source: source, resource: resource, isRequired: isRequired, meta: meta },
        React.createElement(React.Fragment, null,
            React.createElement("div", { ...getRootProps() },
                React.createElement("input", { id: id, ...getInputProps({
                        ...inputProps,
                        ...inputPropsOptions,
                    }) }),
                placeholder ? placeholder : multiple ? React.createElement("p", null, translate(labelMultiple)) : React.createElement("p", null, translate(labelSingle))),
            React.createElement(FormHelperText, null,
                React.createElement(InputHelperText, { touched: touched, error: error, helperText: helperText })),
            React.createElement("div", { className: classes.previewList }, files.map((f, i) => (React.createElement(MinioFilePreview, { file: f, onRemove: onRemove(f), key: i },
                React.createElement(MinioFileField, { ...props, file: f }))))))));
};
function MinioFileField(props) {
    const minio = useMinio();
    let { file, bucketUrl } = props;
    let objectKey = "";
    if (typeof file === "string") {
        objectKey = file;
    }
    let url = "";
    if (objectKey) {
        url = minio.convertUrl(objectKey, bucketUrl);
    }
    else if (file instanceof File) {
        url = URL.createObjectURL(file);
    }
    React.useEffect(() => {
        return () => {
            if (file instanceof File)
                URL.revokeObjectURL(url);
        };
    }, [file]);
    if (file instanceof File) ;
    else if (objectKey) {
        objectKey.split("/").pop();
    }
    return React.createElement(ImageCard, { url: url });
}
function ImageCard(props) {
    const { url } = props;
    const classes = useStyles();
    return (React.createElement(Paper, { className: classes.fileCard },
        React.createElement("img", { src: url, className: classes.image })));
}

const FILTERS = {
    eq: (f, v) => `${f} == ${JSON.stringify(v)}`,
    neq: (f, v) => `${f} != ${JSON.stringify(v)}`,
    gt: (f, v) => `${f} > ${JSON.stringify(v)}`,
    gte: (f, v) => `${f} >= ${JSON.stringify(v)}`,
    lt: (f, v) => `${f} < ${JSON.stringify(v)}`,
    lte: (f, v) => `${f} <= ${JSON.stringify(v)}`,
    contains: (f, v) => `${f}.toLower().contains(${JSON.stringify(v)}.toLower())`,
    cscontains: (f, v) => `${f}.contains(${JSON.stringify(v)})`,
    // build a filter like `$myCol in ($val1, $val2)`
    in: (f, values) => `${f} in (${values.map((v) => JSON.stringify(v)).join(", ")})`,
};
const makeFilter = (field, op, value) => {
    const filter = FILTERS[op];
    if (filter === undefined) {
        throw new Error(`Invalid operation. Only ${Object.keys(FILTERS).join(", ")} are supported.`);
    }
    return filter(field, value);
};
const makeListRequestParams = (params) => {
    const consoleTableObj = {};
    const { page, perPage } = params.pagination;
    const { order, field } = params.sort;
    const flatFilters = flatten(params.filter);
    const filters = Object.keys(flatFilters).map((key) => {
        if (!key.includes("__")) {
            // if filter is custom query
            const customFilter = Array.isArray(flatFilters[key])
                ? key.replaceAll("$", flatFilters[key].map((v) => JSON.stringify(v)).join(", "))
                : key.replaceAll("$", JSON.stringify(flatFilters[key]));
            if (process.env.NODE_ENV === "development") {
                Object.assign(consoleTableObj, {
                    [customFilter]: {
                        operation: "custom",
                        value: JSON.stringify(flatFilters[key]),
                        filter: customFilter,
                    },
                });
            }
            return customFilter;
        }
        const value = flatFilters[key];
        const [field, op] = key.split("__");
        const filter = makeFilter(field, op, value);
        if (process.env.NODE_ENV === "development") {
            Object.assign(consoleTableObj, {
                [field]: {
                    operation: op,
                    value: JSON.stringify(flatFilters[key]),
                    filter,
                },
            });
        }
        return filter;
    });
    if (process.env.NODE_ENV === "development" && filters.length > 0) {
        const label = "Filters";
        console.groupCollapsed(label);
        console.table(consoleTableObj);
        console.info({ createdQuery: filters.map((f) => `(${f})`).join(" && ") });
        console.groupEnd();
    }
    return {
        pageIndex: page - 1,
        pageSize: perPage,
        sorts: `${field} ${order}`,
        filter: filters.map((f) => `(${f})`).join(" && "),
    };
};
const flatten = (target, opts = {}) => {
    const delimiter = opts.delimiter || ".";
    const maxDepth = opts.maxDepth;
    const transformKey = (k) => k;
    const output = {};
    function step(object, prev, currentDepth) {
        currentDepth = currentDepth || 1;
        Object.keys(object).forEach(function (key) {
            const value = object[key];
            const isarray = opts.safe && Array.isArray(value);
            const type = Object.prototype.toString.call(value);
            // dont flatten arrays into `arr.0`, `arr.1` keys, process objects only
            const isobject = type === "[object Object]";
            const newKey = prev ? prev + delimiter + transformKey(key) : transformKey(key);
            if (!isarray && isobject && Object.keys(value).length && (!opts.maxDepth || currentDepth < maxDepth)) {
                return step(value, newKey, currentDepth + 1);
            }
            output[newKey] = value;
        });
    }
    // @ts-ignore
    step(target);
    return output;
};
const ttmsDataProvider = (baseUrl, config = { secureFileUpload: false }) => {
    const http = (config === null || config === void 0 ? void 0 : config.axios) || createAxios({ baseURL: baseUrl });
    const urlOf = (...parts) => [baseUrl, ...parts].map((p) => `${p}`.replace(/^\/|\/$/g, "")).join("/");
    const uploadFile = async (file, { onProgress } = {
        onProgress: () => { },
    }) => {
        let signUrlEndpoint = urlOf("minio");
        if (config.secureFileUpload) {
            var formData = new FormData();
            formData.append("file", file);
            const { data: { objectKey }, } = await http.post(signUrlEndpoint, formData, {
                headers: {
                    "Content-Type": file.type,
                    "Mime-Type": file.type,
                },
                onUploadProgress: (evt) => {
                    let fraction = +(evt.loaded / evt.total).toFixed(2);
                    store === null || store === void 0 ? void 0 : store.dispatch(uploadProgress(file.name, fraction));
                    onProgress && onProgress(fraction);
                },
            });
            return { data: { objectKey } };
        }
        else {
            signUrlEndpoint = urlOf("minio", encodeURIComponent(file.name));
            const { data: { url, objectKey }, } = await http.put(signUrlEndpoint);
            await http.put(url, file, {
                headers: {
                    "Content-Type": file.type,
                    Authorization: "",
                },
                onUploadProgress: (evt) => {
                    let fraction = +(evt.loaded / evt.total).toFixed(2);
                    store === null || store === void 0 ? void 0 : store.dispatch(uploadProgress(file.name, fraction));
                    onProgress && onProgress(fraction);
                },
            });
            return { data: { objectKey } };
        }
    };
    async function uploadFilesInForm(formData) {
        const fileFields = findFileFields(formData);
        for (let field of fileFields) {
            const val = formData[field];
            if (val instanceof File) {
                formData[field] = (await uploadFile(val)).data.objectKey;
                continue;
            }
            if (Array.isArray(val)) {
                const files = val.filter((item) => item instanceof File);
                const existingFiles = val.filter((item) => !(item instanceof File));
                const uploaded = await Promise.all(files.map((f) => uploadFile(f)));
                const objectKeys = uploaded.map((up) => up.data.objectKey);
                formData[field] = [...existingFiles, ...objectKeys];
            }
        }
        return formData;
    }
    return {
        http,
        baseUrl,
        uploadFile,
        async create(resource, params) {
            const formData = await uploadFilesInForm(params.data);
            const { data } = await http.post(urlOf(resource), formData);
            return { data };
        },
        async delete(resource, params) {
            const { data } = await http.delete(urlOf(resource, params.id));
            return { data };
        },
        async deleteMany(resource, params) {
            const results = await Promise.all(params.ids.map((id) => http.delete(urlOf(resource, id))));
            return {
                data: results.map((r) => r.data),
            };
        },
        async getList(resource, params) {
            const { data } = await http.get(urlOf(resource), {
                params: makeListRequestParams(params),
            });
            return {
                data: data.items,
                total: data.totalCount,
            };
        },
        async getMany(resource, params) {
            const filter = params.ids.map((id) => `id == ${JSON.stringify(id)}`).join(" || ");
            const { data } = await http.get(urlOf(resource), {
                params: {
                    filter: filter,
                    pageSize: 100,
                },
            });
            return { data: data.items };
        },
        async getManyReference(resource, params) {
            const { data } = await http.get(urlOf(resource), {
                params: {
                    filter: `${params.target}==${JSON.stringify(params.id)}`,
                    sorts: `${params.sort.field} ${params.sort.order}`,
                    pageIndex: params.pagination.page - 1,
                    pageSize: params.pagination.perPage,
                },
            });
            return { data: data.items, total: data.totalCount };
        },
        async getOne(resource, params) {
            const { data } = await http.get(urlOf(resource, params.id));
            return { data };
        },
        async update(resource, params) {
            const formData = await uploadFilesInForm(params.data);
            const { data } = await http.put(urlOf(resource), { ...formData, id: params.id });
            return { data };
        },
        async updateMany(resource, params) {
            const results = await Promise.all(params.ids.map((id) => http.put(urlOf(resource, id), { id, ...params.data })));
            return {
                data: results.map((r) => r.data),
            };
        },
    };
};
function findFileFields(formData) {
    return Object.keys(formData).filter((k) => {
        const val = formData[k];
        const isSingleFile = val instanceof File;
        const isMultipleFiles = Array.isArray(val) && val.some((item) => item instanceof File);
        return isSingleFile || isMultipleFiles;
    });
}

const TTListContext = createContext({});
const useTtList = () => useContext(TTListContext);

const TTList = ({ resource, createModeType = "inline", ...props }) => {
    const [createMode, setCreateMode] = useState(false);
    let { basePath } = props;
    if (basePath === undefined) {
        props.basePath = `/${resource}`;
    }
    let config = {
        createMode: false,
    };
    config.setCreateMode = setCreateMode;
    config.createMode = createMode;
    config.createModeType = createModeType;
    return (React__default.createElement(ResourceContextProvider, { value: resource },
        React__default.createElement(TTListContext.Provider, { value: config },
            React__default.createElement(List$1, { ...props }, props.children))));
};

const defaultFilter = {};
/**
 * A hook for choosing a reference record. Useful for foreign keys.
 *
 * This hook fetches the possible values in the reference resource
 * (using `dataProvider.getList()`), it returns the possible choices
 * as the `choices` attribute.
 *
 * @example
 * const {
 *      choices, // the available reference resource
 * } = useTTReferenceInputController({
 *      input, // the input props
 *      resource: 'comments',
 *      reference: 'posts',
 *      source: 'post_id',
 * });
 *
 * The hook also allow to filter results. It returns a `setFilter`
 * function. It uses the value to create a filter
 * for the query - by default { q: [searchText] }. You can customize the mapping
 * searchText => searchQuery by setting a custom `filterToQuery` function option
 * You can also add a permanentFilter to further filter the result:
 *
 * @example
 * const {
 *      choices, // the available reference resource
 *      setFilter,
 * } = useTTReferenceInputController({
 *      input, // the input props
 *      resource: 'comments',
 *      reference: 'posts',
 *      source: 'post_id',
 *      permanentFilter: {
 *          author: 'john'
 *      },
 *      filterToQuery: searchText => ({ title: searchText })
 * });
 */
const useTTReferenceInputController = (props) => {
    const { basePath, input, page: initialPage = 1, perPage: initialPerPage = 25, filter = defaultFilter, reference, filterToQuery, sort: sortOverride, } = props;
    const resource = useResourceContext(props);
    const translate = useTranslate();
    // pagination logic
    const { pagination, setPagination, page, setPage, perPage, setPerPage } = usePaginationState({
        page: initialPage,
        perPage: initialPerPage,
    });
    // sort logic
    const { sort, setSort: setSortObject } = useSortState(sortOverride);
    const setSort = useCallback((field, order = "ASC") => {
        setSortObject({ field, order });
        setPage(1);
    }, [setPage, setSortObject]);
    // filter logic
    const { filter: filterValues, setFilter } = useFilterState({
        permanentFilter: filter,
        filterToQuery,
    });
    const displayedFilters = [];
    // plus showFilter and hideFilter defined outside of the hook because
    // they never change
    // selection logic
    const { selectedIds, onSelect, onToggleItem, onUnselectItems } = useSelectionState();
    // fetch possible values
    const { ids: possibleValuesIds, data: possibleValuesData, total: possibleValuesTotal, loaded: possibleValuesLoaded, loading: possibleValuesLoading, error: possibleValuesError, refetch, } = useGetList(reference, pagination, sort, filterValues);
    // fetch current value
    const { referenceRecord, error: referenceError, loading: referenceLoading, loaded: referenceLoaded } = useReference({
        id: input.value,
        reference,
    });
    // add current value to possible sources
    let finalIds, finalData, finalTotal;
    finalIds = possibleValuesIds || [];
    finalData = possibleValuesData || {};
    finalTotal = possibleValuesTotal || 0;
    //   if (!referenceRecord || possibleValuesIds.includes(input.value)) {
    //     finalIds = possibleValuesIds;
    //     finalData = possibleValuesData;
    //     finalTotal = possibleValuesTotal;
    //   } else {
    //     finalIds = [input.value, ...possibleValuesIds];
    //     finalData = { [input.value]: referenceRecord, ...possibleValuesData };
    //     finalTotal += 1;
    //   }
    // overall status
    const refRecord = referenceRecord || {};
    const dataStatus = getStatusForInput({
        input,
        matchingReferences: Object.keys(finalData).map((id) => finalData[id]),
        referenceRecord: refRecord,
        translate,
    });
    return {
        // should match the ListContext shape
        possibleValues: {
            refetch,
            basePath: basePath || "",
            data: finalData,
            ids: finalIds,
            total: finalTotal,
            error: possibleValuesError,
            loaded: possibleValuesLoaded,
            loading: possibleValuesLoading,
            hasCreate: false,
            page,
            setPage,
            perPage,
            setPerPage,
            currentSort: sort,
            setSort,
            filterValues,
            displayedFilters,
            setFilters: setFilter,
            showFilter,
            hideFilter,
            selectedIds,
            onSelect,
            onToggleItem,
            onUnselectItems,
            resource,
        },
        referenceRecord: {
            data: referenceRecord,
            loaded: referenceLoaded,
            loading: referenceLoading,
            error: referenceError,
        },
        dataStatus: {
            error: dataStatus.error,
            loading: dataStatus.waiting,
            warning: dataStatus.warning,
        },
        choices: finalIds.map((id) => finalData[id]),
        // kept for backwards compatibility
        // @deprecated to be removed in 4.0
        error: dataStatus.error,
        loading: !possibleValuesLoaded || !referenceLoaded,
        filter: filterValues,
        setFilter,
        pagination,
        setPagination,
        sort,
        setSort: setSortObject,
        warning: dataStatus.warning,
    };
};
const hideFilter = () => { };
const showFilter = () => { };

/**
 * An Input component for choosing a reference record. Useful for foreign keys.
 *
 * This component fetches the possible values in the reference resource
 * (using `dataProvider.getList()`), then delegates rendering
 * to a subcomponent, to which it passes the possible choices
 * as the `choices` attribute.
 *
 * Use it with a selector component as child, like `<AutocompleteInput>`,
 * `<SelectInput>`, or `<RadioButtonGroupInput>`.
 *
 * @example
 * export const CommentEdit = (props) => (
 *     <Edit {...props}>
 *         <SimpleForm>
 *             <ReferenceInput label="Post" source="post_id" reference="posts">
 *                 <AutocompleteInput optionText="title" />
 *             </ReferenceInput>
 *         </SimpleForm>
 *     </Edit>
 * );
 *
 * @example
 * export const CommentEdit = (props) => (
 *     <Edit {...props}>
 *         <SimpleForm>
 *             <ReferenceInput label="Post" source="post_id" reference="posts">
 *                 <SelectInput optionText="title" />
 *             </ReferenceInput>
 *         </SimpleForm>
 *     </Edit>
 * );
 *
 * By default, restricts the possible values to 25. You can extend this limit
 * by setting the `perPage` prop.
 *
 * @example
 * <ReferenceInput
 *      source="post_id"
 *      reference="posts"
 *      perPage={100}>
 *     <SelectInput optionText="title" />
 * </ReferenceInput>
 *
 * By default, orders the possible values by id desc. You can change this order
 * by setting the `sort` prop (an object with `field` and `order` properties).
 *
 * @example
 * <ReferenceInput
 *      source="post_id"
 *      reference="posts"
 *      sort={{ field: 'title', order: 'ASC' }}>
 *     <SelectInput optionText="title" />
 * </ReferenceInput>
 *
 * Also, you can filter the query used to populate the possible values. Use the
 * `filter` prop for that.
 *
 * @example
 * <ReferenceInput
 *      source="post_id"
 *      reference="posts"
 *      filter={{ is_published: true }}>
 *     <SelectInput optionText="title" />
 * </ReferenceInput>
 *
 * The enclosed component may filter results. ReferenceInput passes a `setFilter`
 * function as prop to its child component. It uses the value to create a filter
 * for the query - by default { q: [searchText] }. You can customize the mapping
 * searchText => searchQuery by setting a custom `filterToQuery` function prop:
 *
 * @example
 * <ReferenceInput
 *      source="post_id"
 *      reference="posts"
 *      filterToQuery={searchText => ({ title: searchText })}>
 *     <AutocompleteInput optionText="title" />
 * </ReferenceInput>
 */
const TTReferenceInput = ({ format, onBlur, onChange, onFocus, parse, validate, ...props }) => {
    const inputProps = useInput$1({
        format,
        onBlur,
        onChange,
        onFocus,
        parse,
        validate,
        ...props,
    });
    return (
    /* @ts-ignore */
    React__default.createElement(ReferenceInputView, { ...inputProps, ...props, ...useTTReferenceInputController({ ...props, ...inputProps }) }));
};
TTReferenceInput.propTypes = {
    allowEmpty: PropTypes.bool,
    basePath: PropTypes.string,
    children: PropTypes.element.isRequired,
    className: PropTypes.string,
    classes: PropTypes.object,
    filter: PropTypes.object,
    filterToQuery: PropTypes.func.isRequired,
    label: PropTypes.string,
    onChange: PropTypes.func,
    perPage: PropTypes.number,
    record: PropTypes.object,
    reference: PropTypes.string.isRequired,
    resource: PropTypes.string,
    sort: PropTypes.shape({
        field: PropTypes.string,
        order: PropTypes.oneOf(["ASC", "DESC"]),
    }),
    source: PropTypes.string.isRequired,
};
TTReferenceInput.defaultProps = {
    filter: {},
    filterToQuery: (searchText) => (searchText ? { q: searchText } : {}),
    perPage: 25,
    sort: { field: "id", order: "DESC" },
};
const ReferenceInputView = ({ allowEmpty, basePath, children, choices, classes, className, error, helperText, id, input, isRequired, loading, label, meta, possibleValues, resource, reference, setFilter, setPagination, setSort, source, warning: warning$1, ...rest }) => {
    if (Children.count(children) !== 1) {
        throw new Error("<ReferenceInput> only accepts a single child");
    }
    if (loading) {
        return (React__default.createElement(Labeled$1, { id: id, label: label, source: source, resource: resource, className: className, isRequired: isRequired, meta: meta, input: input },
            React__default.createElement(LinearProgress$1, null)));
    }
    // This is not a final-form error but an unrecoverable error from the
    // useReferenceInputController hook
    if (error) {
        return React__default.createElement(ReferenceError, { label: label, error: error });
    }
    // When the useReferenceInputController returns a warning, it means there it
    // had an issue trying to load the referenced record
    // We display it by overriding the final-form meta
    const finalMeta = warning$1
        ? {
            ...meta,
            error: warning$1,
        }
        : meta;
    // helperText should never be set on ReferenceInput, only in child component
    // But in a Filter component, the child helperText have to be forced to false
    warning(helperText !== undefined && helperText !== false, "<ReferenceInput> doesn't accept a helperText prop. Set the helperText prop on the child component instead");
    const disabledHelperText = helperText === false ? { helperText } : {};
    return (React__default.createElement(ResourceContextProvider$1, { value: reference },
        React__default.createElement(ListContextProvider, { value: possibleValues }, cloneElement(children, {
            allowEmpty,
            classes,
            className,
            input,
            isRequired,
            label,
            resource,
            meta: finalMeta,
            source,
            choices,
            basePath,
            setFilter,
            setPagination,
            setSort,
            translateChoice: false,
            ...disabledHelperText,
            ...rest,
        }))));
};
const ReferenceError = ({ label, error }) => (React__default.createElement(TextField, { error: true, disabled: true, label: label, value: error, margin: "normal" }));
ReferenceError.propTypes = {
    error: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
};

const TTDependentReferenceInput = (props) => {
    const { dependsOn, lookupField, hideEmpty, disableEmpty, ...rest } = props;
    const { values: { [dependsOn]: fkValue }, } = useFormState();
    // console.log({ fkValue, disableEmpty, hideEmpty });
    if (hideEmpty === true && (fkValue === undefined || fkValue == null)) {
        return null;
    }
    if (disableEmpty === true && (fkValue === undefined || fkValue == null)) {
        /* @ts-ignore */
        return (React__default.createElement(TTReferenceInput, { ...rest, disabled: true }, props.children));
    }
    /* @ts-ignore */
    return (React__default.createElement(TTReferenceInput, { filter: { [lookupField]: fkValue }, ...rest }, props.children));
};

const ITEM_HEIGHT = 48;
/** Hide/Show list item with TTColumnSelectInput
 *
 * Props:
 *  - columns
 *  - listName
 *
 * @example
 *
 * import { TTColumnSelectInput } from "@tt/ttms-react-core";
 *
 * const customerListColumns = {
 *   FirstName: <TextField source="firstName" />,
 *   LastName: <TextField source="lastName" />,
 *   Address: <TextField source="address" />,
 *   BirthDate: <TextField source="birthDate" />,
 * };
 *
 * <TTColumnSelectInput columns={customerListColumns} listName="customer.list.columns" />
 *
 * @example
 *
 * import React, { FC } from "react";
 * import { Datagrid, ListProps, TextField, TopToolbar, CreateButton, ExportButton } from "react-admin";
 * import { useTTSelectedColumns, TTList, TTColumnSelectInput, useHasAccess, RestrictedComponent } from "@tt/ttms-react-core";
 *
 * const customerListColumns = {
 *   FirstName: <TextField source="firstName" />,
 *   LastName: <TextField source="lastName" />,
 *   Address: <TextField source="address" />,
 *   BirthDate: <TextField source="birthDate" />,
 * };
 *
 * const CustomerListActions = (props) => {
 *  return (
 *    <TopToolbar>
 *      <RestrictedComponent resource="customers" action="export" restrictionProps={{ disabled: true }}>
 *        <ExportButton />
 *      </RestrictedComponent>
 *      <CreateButton basePath={props.basePath} />
 *
 *      <TTColumnSelectInput columns={customerListColumns} listName="customer.list.columns" />
 *
 *    </TopToolbar>
 *  );
 * };
 *
 *
 * const ColumnSelectListSample: FC<ListProps> = (props) => {
 *   const selectedColumns = useTTSelectedColumns({ columns: customerListColumns, listName: "customer.list.columns" });
 *   return (
 *     <TTList resource="customers" {...props} title="List Columns Select Sample" actions={<CustomerListActions />}>
 *       <Datagrid>{selectedColumns}</Datagrid>
 *     </TTList>
 *   );
 * };
 *
 * export default ColumnSelectListSample;
 *
 */
const TTColumnSelectInput = (props) => {
    const { columns, listName } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [getLocalColumns] = useLocalStorage(listName);
    const [stateColumns, setStateColumns] = useState(getLocalColumns || []);
    const open = Boolean(anchorEl);
    const handleChoice = (event) => {
        if (event.target.checked) {
            setStateColumns((old) => [...old, event.target.value]);
            writeStorage(listName, [...stateColumns, event.target.value]);
        }
        else {
            setStateColumns(stateColumns.filter((column) => column !== event.target.value));
            writeStorage(listName, stateColumns.filter((column) => column !== event.target.value));
        }
    };
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (event) => {
        setAnchorEl(null);
    };
    return (React__default.createElement("div", null,
        React__default.createElement(FormControl, { onChange: handleChoice },
            React__default.createElement(Button$1, { onClick: handleClick },
                React__default.createElement(ViewWeekIcon, null)),
            React__default.createElement(Menu$1, { id: "long-menu", anchorEl: anchorEl, keepMounted: true, open: open, getContentAnchorEl: null, onClose: handleClose, PaperProps: {
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                    },
                } }, Object.keys(columns).map((columnKey, index) => (React__default.createElement(MenuItem$1, { key: index, value: columnKey },
                React__default.createElement(Checkbox, { color: "primary", value: columnKey, checked: stateColumns.indexOf(columnKey) > -1 }),
                React__default.createElement(ListItemText, { primary: columnKey }))))))));
};

/** useTTSelectedColumns Hook bring selected columns.
 *
 * Props:
 *  - columns
 *  - listName
 * @returns selectedColumns
 *
 * @example
 *
 * import { useTTSelectedColumns } from "@tt/ttms-react-core";
 *
 * const customerListColumns = {
 *   FirstName: <TextField source="firstName" />,
 *   LastName: <TextField source="lastName" />,
 *   Address: <TextField source="address" />,
 *   BirthDate: <TextField source="birthDate" />,
 * };
 *
 *  const selectedColumns = useTTSelectedColumns({ columns: customerListColumns, listName: "customer.list.columns" });
 * @example
 *
 * import React, { FC } from "react";
 * import { Datagrid, ListProps, TextField, TopToolbar, CreateButton, ExportButton } from "react-admin";
 * import { useTTSelectedColumns, TTList, TTColumnSelectInput, useHasAccess, RestrictedComponent } from "@tt/ttms-react-core";
 *
 * const customerListColumns = {
 *   FirstName: <TextField source="firstName" />,
 *   LastName: <TextField source="lastName" />,
 *   Address: <TextField source="address" />,
 *   BirthDate: <TextField source="birthDate" />,
 * };
 *
 * const CustomerListActions = (props) => {
 *  return (
 *    <TopToolbar>
 *      <RestrictedComponent resource="customers" action="export" restrictionProps={{ disabled: true }}>
 *        <ExportButton />
 *      </RestrictedComponent>
 *      <CreateButton basePath={props.basePath} />
 *      <TTColumnSelectInput columns={customerListColumns} listName="customer.list.columns" />
 *    </TopToolbar>
 *  );
 * };
 *
 *
 * const ColumnSelectListSample: FC<ListProps> = (props) => {
 *   const selectedColumns = useTTSelectedColumns({ columns: customerListColumns, listName: "customer.list.columns" });
 *   return (
 *     <TTList resource="customers" {...props} title="List Columns Select Sample" actions={<CustomerListActions />}>
 *       <Datagrid>{selectedColumns}</Datagrid>
 *     </TTList>
 *   );
 * };
 *
 * export default ColumnSelectListSample;
 *
 */
const useTTSelectedColumns = (props) => {
    const { columns: availableColumns, listName } = props;
    const [storedColumns] = useLocalStorage(listName);
    if (!storedColumns || (storedColumns === null || storedColumns === void 0 ? void 0 : storedColumns.length) === 0) {
        return Object.values(availableColumns);
    }
    return storedColumns === null || storedColumns === void 0 ? void 0 : storedColumns.filter((colKey) => colKey in availableColumns).map((colKey) => React__default.cloneElement(availableColumns[colKey], { key: colKey }));
};

const ClearInputOnChange = ({ children, event = "onChange", value = null, targetSource }) => {
    const form = useForm();
    if (!Array.isArray(targetSource)) {
        targetSource = [targetSource];
    }
    const clearOtherInput = React__default.useCallback(() => {
        for (const source of targetSource) {
            form.change(source, value);
        }
    }, [targetSource, form]);
    return (React__default.createElement(React__default.Fragment, null, React__default.Children.map(children, (child, _) => {
        if (React__default.isValidElement(child)) {
            return React__default.cloneElement(child, { [event]: clearOtherInput });
        }
        return child;
    })));
};

/**
 * It allows you to perform your download operations via Minio:
 *
 * @example // Usage in List component
 * export const ProductList = (props) => {
 *  return (
 *      <List {...props}>
 *          <Datagrid rowClick="edit">
 *              <TextField source="name"/>
 *              <NumberField source="price"/>
 *              <TTDownloadButton target="image" buttonText="Download" variant="outlined"/>
 *          </Datagrid>
 *      </List>
 *  );
 * };
 *
 * @example // Usage in Show component
 * <Show {...props}>
 *    <SimpleShowLayout>
 *        <TextField source="id" />
 *        <ReferenceField source="categoryId" reference="categories"><TextField source="id" /></ReferenceField>
 *        <DateField source="reference" />
 *        <NumberField source="width" />
 *        <NumberField source="height" />
 *        <NumberField source="price" />
 *        <TextField source="thumbnail" />
 *        <TextField source="image" />
 *        <TextField source="description" />
 *        <NumberField source="stock" />
 *        <TTDownloadButton target="image" />
 *    </SimpleShowLayout>
 *</Show>

/**
 * Modern browsers can download files that aren't from same origin this is a workaround to download a remote file
 * @param `target` field for the file to be downloaded
 */
const TTDownloadButton = (props) => {
    const { record, target, label = "", ...rest } = props;
    const { tokens } = useTtmsAuth();
    const { apiBaseUrl } = useTtmsAppConfig();
    const url = record ? `${apiBaseUrl}/minio/${record[target]}?token=${tokens === null || tokens === void 0 ? void 0 : tokens.accessToken}` : `${apiBaseUrl}/minio/${target}?token=${tokens === null || tokens === void 0 ? void 0 : tokens.accessToken}`;
    const fileName = record ? record[target] : target;
    if (record) {
        return record[target] ? React__default.createElement(DownloadButton, { url: url, filename: fileName, ...rest }) : null;
    }
    return target ? React__default.createElement(DownloadButton, { url: url, filename: fileName, ...rest }) : null;
};
const defaultIcon = React__default.createElement(CloudDownload, null);
const DownloadButton = ({ url, filename, ...props }) => {
    const { icon = defaultIcon, buttonText = 'Download', variant = "text", label = "", } = props;
    const [fetching, setFetching] = useState(false);
    const notify = useNotify();
    const fetchFromUrl = (url, name) => {
        if (!url) {
            throw new Error("Resource URL not provided! You need to provide one");
        }
        setFetching(true);
        fetch(url)
            .then((response) => response.blob())
            .then((blob) => {
            setFetching(false);
            const blobURL = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobURL;
            //@ts-ignore
            a.style = "display: none";
            if (name && name.length)
                a.download = name;
            document.body.appendChild(a);
            a.click();
        })
            .catch((error) => {
            notify("An error occured during download", "error");
            throw new Error(error);
        });
    };
    return (React__default.createElement(Button$1, { variant: variant, disabled: fetching, onClick: (e) => {
            e.stopPropagation();
            fetchFromUrl(url, filename);
        }, redirect: false, startIcon: icon, label: buttonText, ...props }));
};

/**
 * Form input to edit a Date value in the format you specify (e.g. 'YYYY/MM/DD').
 *
 * Renders a date picker from Material-UI pickers
 *
 * @example
 * import { Edit, SimpleForm } from 'react-admin';
 * import { TTDateInput } from "@tt/ttms-react-core";
 *
 * const PostEdit = (props) => (
 *     <Edit {...props}>
 *         <SimpleForm>
 *             <TTDateInput source="published_at" options={{ format: "YYYY/MM/DD" }} />
 *         </SimpleForm>
 *     </Edit>
 * );
 *
 * @example
 */
const TTDateInput = ({ defaultValue, label, source, resource, className, variant = "filled", disableToolbar = false, locale = tr, helperText, options = { format: "DD/MM/YYYY" }, margin = "dense", onBlur, onChange, onFocus, validate, inputVariant = "inline", fullWidth, ...rest }) => {
    const { id, input, isRequired, meta } = useInput({
        formatOnBlur: true,
        onBlur,
        onChange,
        onFocus,
        resource,
        source,
        validate,
        ...rest,
    });
    const { touched, error, submitError } = meta;
    const handleChange = useCallback((value) => {
        const date = new Date(value);
        Date.parse(value) ? input.onChange(getLocalISOString(date)) : input.onChange(null);
    }, [input.value]);
    /*
     * ISO 8601 date string – like Date.prototype.toISOString(), but with local timezone offset
     * https://gist.github.com/loilo/736d5beaef4a96d652f585b1b678a12c
     */
    function getLocalISOString(date) {
        const offset = date.getTimezoneOffset();
        const offsetAbs = Math.abs(offset);
        const isoString = new Date(date.getTime() - offset * 60 * 1000).toISOString();
        return `${isoString.slice(0, -1)}${offset > 0 ? "-" : "+"}${String(Math.floor(offsetAbs / 60)).padStart(2, "0")}:${String(offsetAbs % 60).padStart(2, "0")}`;
    }
    return (React__default.createElement(MuiPickersUtilsProvider, { utils: DayjsUtils, locale: locale },
        React__default.createElement(KeyboardDatePicker, { id: id, ...input, value: input.value ? new Date(input.value) : defaultValue ? getLocalISOString(defaultValue) : null, variant: inputVariant, inputVariant: variant, margin: margin, error: !!(touched && error), helperText: React__default.createElement(InputHelperText, { touched: touched, error: error || submitError, helperText: helperText }), label: React__default.createElement(FieldTitle, { label: label, source: source, resource: resource }), required: isRequired, className: className, fullWidth: fullWidth, disableToolbar: disableToolbar, onChange: (date) => handleChange(date), onFocus: onFocus, onBlur: onBlur, ...options, ...rest })));
};

/**
 * Input component for entering a date and a time (e.g. 'DD/MM/YYYY, HH:mm:ss').
 *
 * Renders a DateTime picker from Material-UI pickers
 *
 * @example
 * import { Edit, SimpleForm } from 'react-admin';
 * import { TTDateTimeInput } from "@tt/ttms-react-core";
 *
 * const PostEdit = (props) => (
 *     <Edit {...props}>
 *         <SimpleForm>
 *             <TTDateTimeInput source="published_at" options={{ format: 'DD/MM/YYYY, HH:mm:ss' }} disableToolbar={true} isRequired={true} />
 *         </SimpleForm>
 *     </Edit>
 * );
 *
 * @example
 **/
const TTDateTimeInput = ({ defaultValue, label, helperText, margin = "dense", onBlur, onChange, onFocus, options = { format: "DD/MM/YYYY, HH:mm:ss" }, source, resource, className, validate, variant = "filled", disableToolbar = false, locale = tr, inputVariant = "inline", ampm = false, ...rest }) => {
    const { id, input, isRequired, meta } = useInput({
        formatOnBlur: true,
        onBlur,
        onChange,
        onFocus,
        resource,
        source,
        validate,
        ...rest,
    });
    const { touched, error, submitError } = meta;
    const handleChange = useCallback((value) => {
        const date = new Date(value);
        Date.parse(value) ? input.onChange(getLocalISOString(date)) : input.onChange(null);
    }, [input.value]);
    /*
     * ISO 8601 date string – like Date.prototype.toISOString(), but with local timezone offset
     * https://gist.github.com/loilo/736d5beaef4a96d652f585b1b678a12c
     */
    function getLocalISOString(date) {
        const offset = date.getTimezoneOffset();
        const offsetAbs = Math.abs(offset);
        const isoString = new Date(date.getTime() - offset * 60 * 1000).toISOString();
        return `${isoString.slice(0, -1)}${offset > 0 ? "-" : "+"}${String(Math.floor(offsetAbs / 60)).padStart(2, "0")}:${String(offsetAbs % 60).padStart(2, "0")}`;
    }
    return (React__default.createElement(MuiPickersUtilsProvider, { utils: DayjsUtils, locale: locale },
        React__default.createElement(KeyboardDateTimePicker, { id: id, ...input, value: input.value ? new Date(input.value) : defaultValue ? getLocalISOString(defaultValue) : null, variant: inputVariant, inputVariant: variant, margin: margin, error: !!(touched && error), helperText: React__default.createElement(InputHelperText, { touched: touched, error: error || submitError, helperText: helperText }), label: React__default.createElement(FieldTitle, { label: label, source: source, resource: resource }), required: isRequired, className: className, disableToolbar: disableToolbar, onChange: (date) => handleChange(date), onFocus: onFocus, onBlur: onBlur, ampm: ampm, ...options, ...rest })));
};

/**
 * An Input component you can apply mask
 *
 * @example
 * <TTMaskInput source="phone" mask="(999) 999 99 99" />
 *
 */
const TTMaskInput = (props) => {
    const { label, source, resource, className, mask, maskChar, disabled, variant = "filled", margin = "dense", helperText, formatChars, alwaysShowMask, inputRef, } = props;
    const { input: { name, onChange, onFocus, onBlur, value, ...rest }, meta: { touched, error, submitError }, isRequired, } = useInput(props);
    return (React__default.createElement(InputMask, { mask: mask, value: value, disabled: disabled, onChange: onChange, onFocus: onFocus, onBlur: onBlur, maskChar: maskChar, formatChars: formatChars, alwaysShowMask: alwaysShowMask, inputRef: inputRef }, () => (React__default.createElement(TextField$1, { name: name, variant: variant, margin: margin, error: !!(touched && error), helperText: React__default.createElement(InputHelperText, { touched: touched, error: error || submitError, helperText: helperText }), label: React__default.createElement(FieldTitle, { label: label, source: source, resource: resource }), required: isRequired, className: className, onChange: onChange, onFocus: onFocus, onBlur: onBlur, ...rest }))));
};

const TTEditableDatagridBody = React__default.forwardRef(({ basePath, children, classes, className, data, expand, hasBulkActions, hover, ids, onToggleItem, resource, row, rowClick, rowStyle, selectedIds, isRowSelectable, createForm, editForm, ...rest }, ref) => {
    const { createMode, createModeType } = useTtList();
    return (React__default.createElement(TableBody, { ref: ref, className: classnames("datagrid-body", className), ...rest },
        createMode &&
            createModeType === "inline" &&
            React__default.cloneElement(createForm, {
                basePath,
                resource,
                hasBulkActions,
                className: classes.rowCell,
                isCreateForm: true,
            }),
        ids.map((id, rowIndex) => cloneElement(row, {
            basePath,
            classes,
            className: classnames(classes.row, {
                [classes.rowEven]: rowIndex % 2 === 0,
                [classes.rowOdd]: rowIndex % 2 !== 0,
                [classes.clickableRow]: rowClick,
            }),
            expand,
            hasBulkActions: hasBulkActions && !!selectedIds,
            hover,
            id,
            key: id,
            onToggleItem,
            record: data[id],
            resource,
            rowClick,
            selectable: !isRowSelectable || isRowSelectable(data[id]),
            selected: selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.includes(id),
            style: rowStyle ? rowStyle(data[id], rowIndex) : null,
        }, children))));
});
TTEditableDatagridBody.propTypes = {
    basePath: PropTypes.string,
    classes: PropTypes.any,
    className: PropTypes.string,
    children: PropTypes.node,
    // @ts-ignore
    data: PropTypes.object.isRequired,
    // @ts-ignore
    expand: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType]),
    hasBulkActions: PropTypes.bool.isRequired,
    hover: PropTypes.bool,
    ids: PropTypes.arrayOf(PropTypes.any).isRequired,
    onToggleItem: PropTypes.func,
    resource: PropTypes.string,
    row: PropTypes.element,
    rowClick: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    rowStyle: PropTypes.func,
    selectedIds: PropTypes.arrayOf(PropTypes.any),
    styles: PropTypes.object,
    isRowSelectable: PropTypes.func,
};
TTEditableDatagridBody.defaultProps = {
    data: {},
    hasBulkActions: false,
    ids: [],
    row: React__default.createElement(DatagridRow, null),
};
// trick material-ui Table into thinking this is one of the child type it supports
// @ts-ignore
TTEditableDatagridBody.muiName = "TableBody";
const areEqual = (prevProps, nextProps) => {
    const { children: _1, expand: _2, row: _3, ...prevPropsWithoutChildren } = prevProps;
    const { children: _4, expand: _5, row: _6, ...nextPropsWithoutChildren } = nextProps;
    return shallowEqual(prevPropsWithoutChildren, nextPropsWithoutChildren);
};
const PureDatagridBody = memo(TTEditableDatagridBody, areEqual);
// trick material-ui Table into thinking this is one of the child type it supports
// @ts-ignore
PureDatagridBody.muiName = "TableBody";
// @ts-ignore
PureDatagridBody.defaultProps = {
    row: React__default.createElement(PureDatagridRow, null),
};

const overflowBlur = makeStyles({
    rowCell: {
        maxWidth: 100,
        whiteSpace: "nowrap",
        overflow: "hidden",
        position: "relative",
        "&::after": {
            content: "' '",
            backgroundImage: "linear-gradient(to right, rgba(255, 255, 255, 0), #FFFFFF)",
            width: "32px",
            position: "absolute",
            right: "0px",
            top: "0px",
            height: "100%",
        },
    },
    row: {
        "&:hover": {
            backgroundColor: "#f5f5f5",
            "& $rowCell::after": {
                backgroundImage: "linear-gradient(to right, rgba(235, 236, 240, 0), #f5f5f5)",
                width: "32px",
            },
        },
    },
});
const overflowEllipsis = makeStyles({
    rowCell: {
        maxWidth: 100,
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
    },
    row: {
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
    },
});

const TTRowEditButton = (props) => {
    return (React__default.createElement(Button$1, { label: "", size: "small", color: "inherit", ...props },
        React__default.createElement(EditIcon, { color: "inherit", fontSize: "small" })));
};
TTRowEditButton.defaultProps = {
    isEditRowButton: true,
};

const TTRowDeleteButton = (props) => {
    const { record, disabled, resource, ...rest } = props;
    const [loading, setLoading] = useState(false);
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const handleClick = useCallback(() => {
        setLoading(true);
        const env = process.env.APP_ENV || process.env.NODE_ENV;
        dataProvider
            .delete(resource, { id: record.id })
            .then(() => {
            refresh();
            notify("Record deleted", "info");
            setLoading(false);
        })
            .catch((err) => {
            if (["development", "local"].includes(env)) {
                console.error(err);
            }
            notify("An error occurred", "error");
            setLoading(false);
        });
    }, [props]);
    return (React__default.createElement(Button, { disabled: loading, onClick: handleClick, ...rest },
        React__default.createElement(DeleteOutlineIcon, { fontSize: "small" })));
};
TTRowDeleteButton.defaultProps = {
    isDeleteRowButton: true,
};

const TTEditableDatagridRow = React__default.forwardRef((props, ref) => {
    const { record, resource, id, onToggleItem, children, editForm, createForm, selected, selectable, basePath, className, style, hover, hasBulkActions, classes, expand, rowClick, ...rest } = props;
    const [editMode, setEditMode] = useState(false);
    const history = useHistory$1();
    const handleToggleSelection = useCallback((event) => {
        if (!selectable)
            return;
        onToggleItem(id, event);
        event.stopPropagation();
    }, [id, onToggleItem, selectable]);
    const handleClick = useCallback(async (event) => {
        if (!rowClick)
            return;
        event.persist();
        const effect = typeof rowClick === "function" ? await rowClick(id, basePath || `/${resource}`, record) : rowClick;
        switch (effect) {
            case "edit":
                history.push(linkToRecord(basePath || `/${resource}`, id));
                return;
            case "show":
                history.push(linkToRecord(basePath || `/${resource}`, id, "show"));
                return;
            case "toggleSelection":
                handleToggleSelection(event);
                return;
            default:
                if (effect)
                    history.push(effect);
                return;
        }
    }, [
        basePath,
        history,
        // handleToggleExpand,
        handleToggleSelection,
        id,
        record,
        resource,
        rowClick,
    ]);
    if (editMode) {
        return React__default.cloneElement(editForm, {
            record,
            basePath,
            resource,
            editMode,
            setEditMode,
            hasBulkActions,
            id,
            className: classes.rowCell,
        });
    }
    else {
        return (React__default.createElement(TableRow, { ref: ref, key: id, style: style, hover: hover, className: className, onClick: handleClick, ...rest },
            hasBulkActions && (React__default.createElement(TableCell, { padding: "checkbox" },
                React__default.createElement(Checkbox$1, { color: "primary", checked: selected, onClick: handleToggleSelection }))),
            React__default.Children.map(children, (field, index) => {
                var _a;
                if ((_a = field === null || field === void 0 ? void 0 : field.props) === null || _a === void 0 ? void 0 : _a.isActionColumn) {
                    return (React__default.createElement(TableCell, { width: field.props.width }, typeof field.props["children"] === "undefined" ? (React__default.createElement(ButtonGroup, { size: "small", variant: "text" },
                        React__default.createElement(TTRowEditButton, { onClick: () => setEditMode(!editMode) }),
                        React__default.createElement(TTRowDeleteButton, { resource: resource, color: "primary", size: "small", record: record }))) : (React__default.createElement(ButtonGroup, { size: "small", variant: "text" }, field.props.children
                        ? React__default.Children.map(field.props.children, (actionButton) => {
                            var _a, _b;
                            if (!actionButton) {
                                return null;
                            }
                            if ((_a = actionButton.props) === null || _a === void 0 ? void 0 : _a.isEditRowButton) {
                                return React__default.cloneElement(actionButton, {
                                    record,
                                    id,
                                    onClick: () => {
                                        setEditMode(!editMode);
                                    },
                                });
                            }
                            else if ((_b = actionButton.props) === null || _b === void 0 ? void 0 : _b.isDeleteRowButton) {
                                return (React__default.createElement(TTRowDeleteButton, { resource: resource, color: "primary", size: "small", record: record }));
                            }
                            else {
                                return React__default.cloneElement(actionButton, {
                                    record,
                                    id,
                                });
                            }
                        })
                        : null))));
                }
                else {
                    return isValidElement(field) ? (React__default.createElement(DatagridCell, { key: `${id}-${field.props.source || index}`, className: classnames(`column-${field.props.source}`, classes.rowCell), record: record, ...{ field, basePath, resource }, title: record[field.props.source] })) : null;
                }
            })));
    }
});

const TTEditableDatagrid = React__default.memo(({ createForm, editForm, hasBulkActions, overflowStyle = "blur", ...rest }) => {
    const classes = overflowStyle === "blur" ? overflowBlur() : overflowEllipsis();
    return (React__default.createElement(Datagrid, { body: React__default.createElement(TTEditableDatagridBody, { editForm: editForm, createForm: createForm, row: React__default.createElement(TTEditableDatagridRow, { editForm: editForm, createForm: editForm, 
                // {...rest}
                rowClick: rest.rowClick }), rowClick: rest.rowClick }), hasBulkActions: hasBulkActions, classes: classes, rowClick: rest.rowClick, ...rest }));
});

const TTRowCancelButton = (props) => {
    const { onClick, ...rest } = props;
    return (React__default.createElement(Button$1, { label: "", size: "small", onClick: onClick, ...rest },
        React__default.createElement(CloseIcon, { fontSize: "small", style: { color: "#000000de" } })));
};

const TTSaveRowButton = ({ onSubmit, pristine, submitting }) => {
    return (React__default.createElement(Button$1, { disabled: pristine || submitting, size: "small", onClick: onSubmit }, submitting ? (React__default.createElement(CircularProgress$1, { size: 15, thickness: 2 })) : (React__default.createElement(SaveIcon, { fontSize: "small", style: pristine || submitting ? { color: "gray" } : { color: "#1976d2" } }))));
};

const TTRowForm = ({ record, id, className, basePath, resource, selected, children, setEditMode, editMode, hasBulkActions, isCreateForm, classes, validate, onSubmit = null, onSuccess = null, onFailure = null, ...rest }) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const { setCreateMode } = useTtList();
    const defaultHandleEditSubmit = useCallback(async (values) => {
        const env = process.env.APP_ENV || process.env.NODE_ENV;
        try {
            const response = await dataProvider.update(resource, {
                id: record.id,
                data: { ...values },
                previousData: { ...record },
            });
            if (onSuccess) {
                onSuccess(response);
                setEditMode(false);
            }
            else {
                notify("Record updated", { type: "success" });
                setEditMode(false);
            }
        }
        catch (error) {
            if (onFailure) {
                onFailure(error);
            }
            else {
                if (["development", "local"].includes(env)) {
                    console.error(error);
                }
                notify("An error occurred", { type: "error", undoable: true });
            }
        }
    }, []);
    const defaultHandleCreateSubmit = useCallback(async (values) => {
        const env = process.env.APP_ENV || process.env.NODE_ENV;
        try {
            const response = await dataProvider.create(resource, { data: { ...values } });
            if (onSuccess) {
                onSuccess(response);
                setCreateMode(false);
                refresh();
            }
            else {
                setCreateMode(false);
                notify("Record saved", { type: "success" });
                refresh();
            }
        }
        catch (error) {
            if (onFailure) {
                onFailure(error);
            }
            else {
                if (["development", "local"].includes(env)) {
                    console.error(error);
                }
                notify("An error occurred", { type: "error", undoable: true });
            }
        }
    }, []);
    return (React__default.createElement(Form, { initialValues: record, validate: validate, onSubmit: onSubmit !== null && onSubmit !== void 0 ? onSubmit : (isCreateForm ? defaultHandleCreateSubmit : defaultHandleEditSubmit), ...rest }, ({ handleSubmit, pristine, submitting }) => (React__default.createElement(TableRow, { key: id },
        hasBulkActions && (React__default.createElement(TableCell, { padding: "checkbox" },
            React__default.createElement(Checkbox$1, { color: "primary", checked: selected, disabled: true }))),
        React__default.Children.map(children, (child) => {
            var _a;
            if (isValidElement(child) && child.props.isActionColumn) {
                return (React__default.createElement(TableCell, { width: child.props.width }, isCreateForm ? (React__default.createElement(ButtonGroup, { size: "small", variant: "text" },
                    React__default.createElement(TTSaveRowButton, { onSubmit: handleSubmit, pristine: pristine, submitting: submitting }),
                    React__default.createElement(TTRowCancelButton, { onClick: () => setCreateMode(false) }),
                    React__default.Children.map(child.props.children, (additionalButton) => React__default.cloneElement(additionalButton, {
                        record,
                    })))) : (React__default.createElement(ButtonGroup, { size: "small", variant: "text" },
                    React__default.createElement(TTSaveRowButton, { onSubmit: handleSubmit, pristine: pristine, submitting: submitting }),
                    React__default.createElement(TTRowCancelButton, { onClick: () => setEditMode(!editMode) }),
                    React__default.Children.map(child.props.children, (additionalButton) => React__default.cloneElement(additionalButton, {
                        record,
                    }))))));
            }
            else {
                return isValidElement(child) ? (React__default.createElement(TableCell, { key: `${id}-${child.props.source}`, align: child === null || child === void 0 ? void 0 : child.props.textAlign, className: classnames(`column-${(_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.source}`, className) }, React__default.cloneElement(child, {
                    record,
                    basePath,
                    resource,
                    helperText: false,
                }))) : null;
            }
        })))));
};

const TTRowCreateButton = () => {
    const { setCreateMode, createMode } = useTtList();
    return (React__default.createElement(Button$1, { label: "create", onClick: () => setCreateMode(true), disabled: createMode },
        React__default.createElement(ContentAdd, null)));
};

const TTActionColumn = (props) => {
    const { children, record } = props;
    return children
        ? React__default.cloneElement(children, {
            record: record,
            ...props,
        })
        : null;
};
TTActionColumn.defaultProps = {
    width: "80px",
    isActionColumn: true,
};

export { CenteredContent, ClearInputOnChange, MinioField, MinioFileInput, MinioFilePreview, MinioImageInput, RestrictedComponent, RestrictedResource, RestrictedRoute, TTActionColumn, TTColumnSelectInput, TTDateInput, TTDateTimeInput, TTDependentReferenceInput, TTDownloadButton, TTEditableDatagrid, TTList, TTLogo, TTLogoForMobile, TTMaskInput, TTRowCreateButton, TTRowDeleteButton, TTRowEditButton, TTRowForm, TtmsApp, TtmsAppBar, TtmsAppConfigContext, TtmsAppConfigProvider, TtmsAuthContext, TtmsAuthProvider, TtmsAuthService, TtmsLayout, TtmsLogin, TtmsMenu, TtmsMenuContext, TtmsMenuContextProvider, TtmsTopMenu, Unauthorized, anonymousFilter, createAxios, createTtmsAuthProvider, customerFilter, flatten, getEnvironmentConfig, initAxiosInterceptors, permissionFilter, store, ttmsAdminTheme, ttmsDataProvider, uploadProgress, uploadsReducer, useHasAccess, useMinio, useTTDocumentTitle, useTTSelectedColumns, useTtmsAppConfig, useTtmsAuth, useTtmsMenu, useVerifyPermission };
//# sourceMappingURL=index.esm.js.map
